import React, { useContext, useEffect, useState } from "react";
import About1 from "../../assets/images/about1.png";
import About2 from "../../assets/images/about2.png";
import Trishul from "../../assets/images/trishul.png";
import Icon from "../../assets/images/omnamo/icon.png";
import supportImg2 from "../../assets/images/shapes/arrow-1.png";
import "bootstrap/dist/css/bootstrap.min.css";
// import { Link } from "react-router-dom";
import bg from "../../assets/images/new/main-bg.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import prasadBooking from "../../assets/images/new/prasad-booking.png";
import {
  FaRegHandshake,
  FaUserCheck,
  FaEye,
  FaRegCalendarCheck,
  FaTools,
  FaHome,
  FaSmile,
  FaBoxOpen,
  FaHandshake,
} from "react-icons/fa";
import Swastik from "../../assets/images/swastik.png";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import shape1 from "../../assets/images/shapes/about-1-shape-2.png";
import OwlCarousel from "react-owl-carousel3";
import shape2 from "../../assets/images/shapes/service-bg-shape-2-rtl.png";
import FAQSection from "../../Components/FAQSection/FAQ";

import DailyPooja from "../../assets/images/new/DailyPooja.jpg";
import Ecart from "../../assets/images/new/e-cart.jpg";
import Horoscope from "../../assets/images/new/Horoscope.jpg";
import panditBooking from "../../assets/images/new/panditBooking.jpg";
import poojaAtTemple from "../../assets/images/new/poojaAtTemple.jpg";
import templeBooking from "../../assets/images/new/templeBooking.jpg";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import ExitIntentModal from "./ExitIntentModal";
import { Helmet } from "react-helmet-async";
import PujaBookingBannerImg from "../../assets/images/new/PoojaBookingbannerImg.png";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import HoroscopeBannerImg from "../../assets/images/new/HoroscopeBanner.png";
import PujaAtTempleBannerImg from "../../assets/images/new/PujaAtTempleBannerImg.png";
import DailyPujaBookingBannerImg from "../../assets/images/new/DailyPoojaBookingBannerImg.png";
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Support from "../../Components/SupportComponent/Support";
import { MyBookPanditPujaListAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { GetPopularPujaAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { GetPopularDailyPujaAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import BlogCarousel from "../../Components/BlogsSection/BlogsSection";
import "../../Components/DownLoadApp/DownlaodAppLandingPage.css";
import mockup from "../../assets/images/new/mokup.png";
import AppImg from "../../assets/images/new/AppImg.png";
import ComingSoonModal from "../../Components/ComingSoonModal";
import TrendingCategoriesSection from "../../Components/TrendingCategories/TrendingCategoriesSection";
import TrendingStoreProductsCategory from "../../Components/TrendingCategories/TrendingStoreProductsCategory";
import HoroscopeListCards from "../../Components/Horoscope/HoroscopeListCards";
import { GetUserModel } from "../../ApiServices/Profile/ProfileApi";
import toast from "react-hot-toast";
import LoginPopUp from "../../Components/LoginPopup";
import PujaKitSubscriptionLandingPage from "../../Components/PujaKitSubscription/PujaKitSubscriptionLandingPage";
import LandingPujaKit from "../../assets/images/new/LandingPujaKit.jpg";
import LazySection from "../Home/LazySection";
import playStore from "../../assets/images/new/playStore.png";
import ios from "../../assets/images/new/ios.png";
import { SelectLanguageOptions } from "../../middlewares/Utils";
import { langID } from "../../Components/enum";
import { t } from "i18next";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
const ServicesLandingPage = () => {
  const [slug, setSlug] = useState("");
  const [pujaListData, setPujaListData] = useState([]);
  const [pujaDailyListData, setDailyPujaListData] = useState([]);
  const { setLoader, pujaStatus, setPujaStatus, selectedLanguageID } =
    useContext(LoaderContext);
  const [showComingsoonModal, setShowComingSoonModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const service = searchParams.get("servicename");
  const { servicename } = useParams();
  const [showExitIntentModal, setShowExitIntentModal] = useState(false);
  const ItemAddedToast = () => toast("Please Update Your Profile");
  const navigate = useNavigate();
  const [showOpenLoginModal, setShowOpenLoginModal] = useState(false);
  const [isPageRefresh, setIsPageRefresh] = useState(false);
  const [data, setData] = useState([
    {
      headerName: "Pandit Booking Service",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Embrace Divinity with Temple Pujas",
      route: "/services/book-puja",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "Book an Experienced Pandit for Your Puja",
      serviceName: "puja-booking",
      howItWorksMainHeading: "Effortless Path to Divine Blessings",
      howItWorks: [
        {
          howItWorksTitle: "Select Your Ceremony",
          howItWorksDesc:
            "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
        },
        {
          howItWorksTitle: "Book Your Puja",
          howItWorksDesc:
            "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
        },
        {
          howItWorksTitle: "Embrace Sacred Vibes",
          howItWorksDesc:
            "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
        },
      ],
      testimonials: [
        {
          Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
          name: "Rajesh Singh",
          location: "Delhi",
        },
        {
          Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
          name: "Priya Mane",
          location: "Nashik",
        },
        {
          Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
          name: "Amit Kapoor",
          location: "Mumbai",
        },
        {
          Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
          name: "Rajesh Kulkarni",
          location: "Nashik",
        },
      ],
      FaqObj: [
        {
          question: "What types of puja’s can I book?",
          answer:
            "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          color: "#ffa415",
        },
        {
          question: "Can I book recurring pujas?",
          answer:
            "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          color: "#fc5528",
        },
        {
          question: "Are the pandits experienced and qualified?",
          answer:
            "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          color: "#8139e7",
        },
        {
          question: "Can I book a puja for a temple or home location?",
          answer:
            "Yes, you can book a puja for your home, temple, or any preferred location.",
          color: "#8139e7",
        },
        {
          question: "Do you offer online puja services?",
          answer:
            "Yes, we offer virtual pujas where pandits perform rituals online.",
          color: "#8139e7",
        },
        // {
        //   question: "Why is it important How Volunteer?",
        //   answer:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
      ],
      metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
      metaDescription:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Puja Online - Experienced Pandits for All Ceremonies",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What types of puja’s can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book recurring pujas?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
            },
          },
          {
            "@type": "Question",
            name: "Are the pandits experienced and qualified?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a puja for a temple or home location?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book a puja for your home, temple, or any preferred location.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer online puja services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer virtual pujas where pandits perform rituals online.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Puja Online - Experienced Pandits for All Ceremonies",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
    },
    {
      headerName: " Puja Booking Service",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Embrace Divinity with  Pujas",
      route: "/puja-book",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "Book an Puja for Your Spiritual",
      serviceName: "pujas",
      howItWorksMainHeading: "Effortless Path to Divine Blessings",
      howItWorks: [
        {
          howItWorksTitle: "Select Your Ceremony",
          howItWorksDesc:
            "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
        },
        {
          howItWorksTitle: "Book Your Puja",
          howItWorksDesc:
            "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
        },
        {
          howItWorksTitle: "Embrace Sacred Vibes",
          howItWorksDesc:
            "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
        },
      ],
      testimonials: [
        {
          Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
          name: "Rajesh Singh",
          location: "Delhi",
        },
        {
          Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
          name: "Priya Mane",
          location: "Nashik",
        },
        {
          Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
          name: "Amit Kapoor",
          location: "Mumbai",
        },
        {
          Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
          name: "Rajesh Kulkarni",
          location: "Nashik",
        },
      ],
      FaqObj: [
        {
          question: "What types of puja’s can I book?",
          answer:
            "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
          color: "#ffa415",
        },
        {
          question: "Can I book recurring pujas?",
          answer:
            "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
          color: "#fc5528",
        },
        {
          question: "Are the pandits experienced and qualified?",
          answer:
            "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
          color: "#8139e7",
        },
        {
          question: "Can I book a puja for a temple or home location?",
          answer:
            "Yes, you can book a puja for your home, temple, or any preferred location.",
          color: "#8139e7",
        },
        {
          question: "Do you offer online puja services?",
          answer:
            "Yes, we offer virtual pujas where pandits perform rituals online.",
          color: "#8139e7",
        },
        // {
        //   question: "Why is it important How Volunteer?",
        //   answer:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
      ],
      metaTitle: "Book Puja Online - Experienced Pandits for All Ceremonies",
      metaDescription:
        "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
      cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Puja Online - Experienced Pandits for All Ceremonies",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What types of puja’s can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book recurring pujas?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
            },
          },
          {
            "@type": "Question",
            name: "Are the pandits experienced and qualified?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a puja for a temple or home location?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book a puja for your home, temple, or any preferred location.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer online puja services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer virtual pujas where pandits perform rituals online.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Puja Online - Experienced Pandits for All Ceremonies",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
    },
    {
      headerName: "Daily Pandit Booking Service",
      Imgabout1: About1,
      Imgabout2: DailyPooja,
      tagLine: "Embrace Divinity with Temple Pujas",
      sectionTitle: "Book a Pandit for Daily Puja at Your Convenience",
      serviceBannerImg: DailyPujaBookingBannerImg,
      serviceName: "daily-puja-booking",
      howItWorksMainHeading: "Book a Pandit for Daily Puja at Your Convenience",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Ritual",
          howItWorksDesc:
            "Whether it's Ganpati Puja, Navratri Aarti, or a simple morning prayer, select the service you need. We’ll connect you with an experienced pandit. ",
        },
        {
          howItWorksTitle: "Schedule Your Time",
          howItWorksDesc:
            "Pick a date and time that fits your routine. Pandits are available every morning and evening, so you can schedule rituals at your convenience. ",
        },
        {
          howItWorksTitle: "Experience Divine Blessings",
          howItWorksDesc:
            "Your dedicated pandit arrives with all the necessary items for the Puja. Feel peace, positivity, and divine energy fill your space.",
        },
      ],
      testimonials: [
        {
          Desc: " I booked a daily Ganesh Puja, and it has brought so much positivity to my home. The pandit performs the rituals with devotion, and everything is well-organized. Truly grateful.",
          name: "Anjali Rajput",
          location: "Mumbai",
        },
        {
          Desc: " My family wanted a daily Shiv Abhishek, and My OmNamo made it effortless. The pandit is punctual, knowledgeable, and follows proper Vedic traditions. Highly recommended.",
          name: "Suresh Kale",
          location: "Nashik",
        },
        {
          Desc: "I opted for a monthly Lakshmi Puja service, and the experience has been wonderful. The prayers are performed with sincerity, bringing peace and prosperity to our home.",
          name: "Meera Savant",
          location: "Bangalore",
        },
        {
          Desc: "A very good option by Myomnamo for working people who want to stay connected to their faith.",
          name: "Chetan Pawar",
          location: "Chandrapur",
        },
        {
          Desc: "Every morning, I get an update about the puja. It gives a positive start to my day. Grateful to Myomnamo.",
          name: "Arjun Shinde",
          location: "Jalgaon",
        },
      ],
      FaqObj: [
        {
          question: "What is a daily puja booking service?",
          answer:
            "It allows you to book a pandit for performing daily pujas at your home or temple.",
          color: "#ffa415",
        },
        {
          question: "How do I book a pandit for my ritual?",
          answer:
            "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
          color: "#fc5528",
        },
        {
          question: "Can I choose a specific pandit?",
          answer:
            "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
          color: "#8139e7",
        },
        {
          question: "Can I schedule pujas at a fixed time daily?",
          answer:
            "Yes, you can set a fixed time for your daily puja at your convenience.",
          color: "#8139e7",
        },
        {
          question: "Can I book a virtual daily puja?",
          answer: "Yes, we offer online pujas where pandits perform rituals.",
          color: "#8139e7",
        },
        // {
        //   question: "Why is it important How Volunteer?",
        //   answer:
        //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
        //   color: "#399be7",
        // },
      ],
      route: "/services/daily-booking",
      metaTitle:
        "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
      metaDescription:
        "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
      cannonicalLink: "https://www.myomnamo.com/services/daily-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Daily Puja Booking",
            item: "https://www.myomnamo.com/services/daily-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        description:
          "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is a daily puja booking service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "It allows you to book a pandit for performing daily pujas at your home or temple.",
            },
          },
          {
            "@type": "Question",
            name: "How do I book a pandit for my ritual?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
            },
          },
          {
            "@type": "Question",
            name: "Can I choose a specific pandit?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
            },
          },
          {
            "@type": "Question",
            name: "Can I schedule pujas at a fixed time daily?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can set a fixed time for your daily puja at your convenience.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a virtual daily puja?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer online pujas where pandits perform rituals.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
        description:
          "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/daily-puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Looking for a pandit to perform daily pujas at home or at your event? Experienced pandits are available every morning and evening to guide you through your spiritual experience with care and devotion. Whether it's a 10-day Ganpati puja, a Navratri aarti, or any multi-day ceremony, we handle each step with accuracy and respect for tradition. From chanting mantras to performing aartis, we ensure your rituals are done properly. Bring peace, positivity, and divine blessings to your space every day. Experience divine blessings every day with a trusted pandit guiding your rituals.",
    },
    {
      headerName: "Online Puja Samagri Store",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "Embrace Divinity with Temple Pujas",
      serviceBannerImg: EstoreBannerImg,
      route: "/my-store",
      serviceName: "e-store",
      howItWorksMainHeading: "Puja Shopping Made Simple With E-store",
      howItWorks: [
        {
          howItWorksTitle: "Browse & Select",
          howItWorksDesc:
            "Explore our wide range of puja samagri. Choose puja samgari or complete puja kits customised to your spiritual needs. ",
        },
        {
          howItWorksTitle: "Order & Pay",
          howItWorksDesc:
            "Add products to your cart, securely check out, and choose convenient payment options for a smooth shopping experience. ",
        },
        {
          howItWorksTitle: "Receive & Worship",
          howItWorksDesc:
            "Get your order delivered to your door. Perform your rituals peacefully with everything you need ready and sacred.",
        },
      ],
      testimonials: [
        {
          Desc: " I c ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
          name: "Puja More",
          location: "Pune",
        },
        {
          Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
          name: "Vikas Rathi",
          location: "Bangalore",
        },
        {
          Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
          name: "Meenal Shinde",
          location: "Jaipur",
        },
        {
          Desc: "Shopping from Myomnamo’s E-Store was easy and convenient. I got all my puja items in one place, without needing to visit multiple shops.",
          name: "Sagar Shinde",
          location: "Mumbai",
        },
      ],
      FaqObj: [
        {
          question: "What products do you offer?",
          answer:
            "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
          color: "#ffa415",
        },
        {
          question: "Do you offer fast delivery?",
          answer:
            "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
          color: "#fc5528",
        },
        {
          question: "Are the products authentic and blessed?",
          answer:
            "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "Your One-Stop Online E-Store",
      metaTitle: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
      metaDescription:
        "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
      cannonicalLink: "https://www.myomnamo.com/services/e-store",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Samagri Store",
            item: "https://www.myomnamo.com/services/e-store",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        url: "https://www.myomnamo.com/services/e-store",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What products do you offer?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer fast delivery?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
            },
          },
          {
            "@type": "Question",
            name: "Are the products authentic and blessed?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "Myomnamo",
        locale: "en_IN",
      },

      mainContent:
        "Shop for all your puja needs from home. Get puja samagri, complete puja kits, idols, incense, and more. Whether it's for daily pujas or special festivals, have everything ready for your rituals. No need to visit multiple shops, just browse and get items delivered to your door.  Make every ceremony meaningful with the right products, from sacred flowers to holy offerings. Celebrate traditions easily, knowing you have everything needed for a peaceful and complete puja experience. Keep your devotion strong with the right products for every spiritual occasion.",
    },
    {
      headerName: "Online Darshan Booking",
      Imgabout1: About1,
      Imgabout2: templeBooking,
      tagLine: "Embrace Divinity with Temple Pujas",
      sectionTitle: "Easy Temple Darshan Booking Online",
      serviceBannerImg: DarshanBookingBannerImg,
      serviceName: "darshan-booking",
      cannonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      route: "/darshan-booking",
      howItWorksMainHeading: "Simple & Time-Saving Darshan Booking",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Temple",
          howItWorksDesc:
            "Select your temple and preferred date for darshan. Plan your visit effortlessly, even during peak times. ",
        },
        {
          howItWorksTitle: "Book Your Slot",
          howItWorksDesc:
            "Reserve your darshan slot online in minutes. Avoid long queues and secure a peaceful, hassle-free temple experience.",
        },
        {
          howItWorksTitle: "Get Confirmation",
          howItWorksDesc:
            "Receive instant booking confirmation via email or SMS. Show your details at the temple and enjoy your visit stress-free.",
        },
      ],
      testimonials: [
        {
          Desc: " Booking temple darshan online saved me so much time! No long queues and the process was smooth. Truly a divine experience.",
          name: "Rohit Pawar",
          location: "Yeola",
        },
        {
          Desc: "I booked a VIP darshan for my family, and everything went perfectly. The confirmation was instant, and we had a peaceful visit.",
          name: "Neha Tile",
          location: "Nagpur",
        },
        {
          Desc: "This service made temple visits stress-free. I booked my darshan in advance and had a smooth entry without any hassle. Highly recommended.",
          name: "Amit Patil",
          location: "Jaipur",
        },
        {
          Desc: "My elderly parents were able to do darshan without travelling. This meant a lot to us. Thank you Myomnamo.",
          name: "Bhavana Salunkhe",
          location: "Nanded",
        },

        {
          Desc: "The process was simple and the darshan was well organised by Myomnamo.",
          name: "Gaurav Jadhav",
          location: "Ratnagiri",
        },
      ],
      FaqObj: [
        {
          question: "What is the Darshan Booking service?",
          answer:
            "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
          color: "#ffa415",
        },
        {
          question: "Can I book darshan for multiple people?",
          answer:
            "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
          color: "#fc5528",
        },
        {
          question: "Is online booking available for special events?",
          answer:
            "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
          color: "#8139e7",
        },
        {
          question: "Are VIP or special darshan tickets available?",
          answer:
            "Yes, we offer VIP or express darshan bookings at select temples.",
          color: "#8139e7",
        },
      ],
      metaTitle:
        "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
      metaDescription:
        "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
      canonicalLink: "https://www.myomnamo.com/services/darshan-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Darshan Booking",
            item: "https://www.myomnamo.com/services/darshan-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
        url: "https://www.myomnamo.com/services/darshan-booking",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Darshan Booking service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book darshan for multiple people?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is online booking available for special events?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
            },
          },
          {
            "@type": "Question",
            name: "Are VIP or special darshan tickets available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer VIP or express darshan bookings at select temples.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
        description:
          "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/darshan-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Plan your temple visit easily! Book your darshan in advance and skip the long queues. Whether you are visiting for a festival, special puja, or daily prayers, secure your spot in just a few steps. Enjoy a peaceful visit, offer your prayers, and look for blessings without the stress of waiting. Ideal for families, elderly devotees, or anyone wanting a smooth experience. Focus on your devotion and fully immerse yourself in the sacred atmosphere. Booking your darshan makes your visit more organized, giving you more time for prayer and reflection.",
    },
    {
      headerName: "Temple Puja Booking",
      Imgabout1: About1,
      Imgabout2: poojaAtTemple,
      tagLine: "Embrace Divinity with Temple Pujas",
      serviceBannerImg: PujaAtTempleBannerImg,
      route: "/puja-at-temple",
      cannonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      serviceName: "temple-puja",
      sectionTitle: "Perform a Sacred Puja at the Temple",
      howItWorksMainHeading: "Receive Sacred Blessings",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Puja",
          howItWorksDesc:
            "Choose from simple offerings or elaborate ceremonies, and personalize rituals for your spiritual intentions.  ",
        },
        {
          howItWorksTitle: "Book Effortlessly",
          howItWorksDesc:
            "From gathering offerings to preparing the sacred space, we ensure everything is ready so you can focus on your prayers without any worries.",
        },
        {
          howItWorksTitle: "Experience Divinity",
          howItWorksDesc:
            "Participate in sacred rituals, chant mantras, and receive blessings for positivity and well-being.",
        },
      ],
      testimonials: [
        {
          Desc: " I booked a puja at the temple, and everything was perfectly arranged. The rituals were performed beautifully, and I felt truly blessed.",
          name: "Anjali Raut",
          location: "Kolhapur",
        },
        {
          Desc: "Booking a temple puja online was so convenient. No long waits, everything was well-organized, and the prasad delivery was a lovely touch",
          name: "Vikas Mane",
          location: "Delhi",
        },
        {
          Desc: "The puja was conducted exactly as promised, with complete devotion and care. It was a peaceful and divine experience. Highly recommended.",
          name: "Priya Kadam",
          location: "Vashi",
        },
        {
          Desc: "We wanted a puja done in a South Indian temple, and Myomnamo made it happen smoothly.",
          name: "Abhay Nadkarni",
          location: "Mumbai",
        },
        {
          Desc: "Myomnamo helped me book a special temple puja for my son’s birthday. Felt truly blessed.",
          name: "Rahul Chitale",
          location: "Solapur",
        },
      ],
      FaqObj: [
        {
          question: "What is the Puja at Temple service?",
          answer:
            "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
          color: "#ffa415",
        },
        {
          question: "How do I book a puja?",
          answer:
            "You can book online or at the temple. Choose the puja type, date, and time.",
          color: "#fc5528",
        },
        {
          question: "What types of pujas are available?",
          answer:
            "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
          color: "#8139e7",
        },
        {
          question: "Are special or private pujas available?",
          answer:
            "Yes, some temples offer private pujas with personalized rituals.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
      metaDescription:
        "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
      canonicalLink: "https://www.myomnamo.com/services/temple-puja-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Temple Puja",
            item: "https://www.myomnamo.com/services/temple-puja-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is the Puja at Temple service?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
            },
          },
          {
            "@type": "Question",
            name: "How do I book a puja?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book online or at the temple. Choose the puja type, date, and time.",
            },
          },
          {
            "@type": "Question",
            name: "What types of pujas are available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
            },
          },
          {
            "@type": "Question",
            name: "Are special or private pujas available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, some temples offer private pujas with personalized rituals.",
            },
          },
        ],
      },
      metaData: {
        title: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
        description:
          "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/temple-puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Make your temple visit more special with a peaceful puja. Book a puja for any occasion, whether it be birthdays, anniversaries, festivals, or personal prayers. Let the rituals be performed with care and devotion, bringing positivity and blessings into your life. Whether it’s a small offering or a full ceremony, experience the divine atmosphere and connect deeply with your faith. Perfect for individuals, families, or groups looking for a sacred experience. Focus on your prayers while the arrangements are taken care of. Make every visit special and full of positive energy.",
    },
    {
      headerName: "Horoscope Reading",
      Imgabout1: About1,
      Imgabout2: Horoscope,
      tagLine: "Embrace Divinity with Temple Pujas",
      route: "/basic-details",
      serviceBannerImg: HoroscopeBannerImg,
      cannonicalLink: "https://www.myomnamo.com/services/horoscope",
      serviceName: "horoscope",
      sectionTitle: "Know What Your Stars Say",
      howItWorksMainHeading: "How Our Horoscope Reading Works",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Sign",
          howItWorksDesc:
            "Select your zodiac sign to receive a personalized reading about your life, emotions, and future possibilities.",
        },
        {
          howItWorksTitle: "Get Insights Instantly",
          howItWorksDesc:
            "Access daily, weekly, or yearly horoscopes with detailed guidance on love, career, and well-being for extra clarity.",
        },
        {
          howItWorksTitle: "Embrace Your Path",
          howItWorksDesc:
            "Use your horoscope’s advice to make decisions, discover lucky days, and invite more happiness and balance into your life.",
        },
      ],
      testimonials: [
        {
          Desc: "The personalised horoscope report I received from Myomnamo helped me understand many things about my career and personal life. Very insightful.",
          name: "Amit Dumbre",
          location: "Pune",
        },
        {
          Desc: "I wasn’t very serious about astrology before, but the weekly guidance from Myomnamo has actually helped me make better decisions.",
          name: "Vaishali Thakur",
          location: "Nagpur",
        },
        {
          Desc: "Myomnamo’s horoscope reading was detailed and easy to understand. It wasn’t too technical and gave me practical suggestions.",
          name: "Rohit Pansare",
          location: "Nashik",
        },
        {
          Desc: "I started reading the daily horoscope from Myomnamo and it gives me clarity and focus every morning. It feels very accurate and meaningful.",
          name: "Prachi Kelkar",
          location: "Mumbai",
        },
      ],
      FaqObj: [
        {
          question: "What is the Puja at Temple service?",
          answer:
            "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
          color: "#ffa415",
        },
        {
          question: "How do I book a puja?",
          answer:
            "You can book online or at the temple. Choose the puja type, date, and time.",
          color: "#fc5528",
        },
        {
          question: "What types of pujas are available?",
          answer:
            "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
          color: "#8139e7",
        },
        {
          question: "Are special or private pujas available?",
          answer:
            "Yes, some temples offer private pujas with personalized rituals.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Horoscope Readings by Zodiac Sign - Know Your Future",
      metaDescription:
        "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
      canonicalLink: "https://www.myomnamo.com/services/horoscope",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Horoscope",
            item: "https://www.myomnamo.com/services/horoscope",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Horoscope Readings by Zodiac Sign - Know Your Future",
        url: "https://www.myomnamo.com/services/horoscope",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      metaData: {
        title: "Horoscope Readings by Zodiac Sign - Know Your Future",
        description:
          "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/horoscope",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Find out what your future holds with a simple horoscope reading. Learn about your day, week, or year efficiently. Get insights about love, work, health, and more. Whether you have a big decision to make or are just curious, a horoscope reading can guide you. Find out lucky days, helpful advice, and ways to bring more happiness into your life. Perfect for anyone looking for extra clarity and peace of mind. Let the stars guide you toward a brighter future.",
    },
    {
      headerName: "Online Prasad Booking Service",
      Imgabout1: About1,
      Imgabout2: Ecart,
      tagLine: "Embrace Divinity with Temple Prasad",
      serviceBannerImg: prasadBooking,
      route: "/prasad-list",
      serviceName: "online-prasad-booking",
      howItWorksMainHeading: "Book Prasad Online with Myomnamo",
      howItWorks: [
        {
          howItWorksTitle: "Choose & Customize",
          howItWorksDesc:
            "Select your preferred prasad, meal time, and quantity. Pick from a variety of sacred offerings prepared with devotion. ",
        },
        {
          howItWorksTitle: "Book & Pay",
          howItWorksDesc:
            "Complete your booking with a few clicks. Enjoy secure payment options for a hassle-free experience",
        },
        {
          howItWorksTitle: "Receive & Blessings",
          howItWorksDesc:
            "Get the divine prasad delivered to your home. Savour the sacred taste and feel the blessings of the divine.",
        },
      ],
      testimonials: [
        {
          Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
          name: "Puja More",
          location: "Pune",
        },
        {
          Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
          name: "Vikas Rathi",
          location: "Bangalore",
        },
        {
          Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
          name: "Meenal Shinde",
          location: "Jaipur",
        },
        {
          Desc: "I couldn’t go to the temple, but getting prasad made me feel included. Myomnamo is doing a great job.",
          name: "Nitin Korde",
          location: "Pune",
        },
      ],
      FaqObj: [
        {
          question: "Which temples' prasad can I book?",
          answer:
            "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
          color: "#ffa415",
        },
        {
          question: "How long does delivery take?",
          answer:
            "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
          color: "#fc5528",
        },
        {
          question: "Is the prasad prepared hygienically?",
          answer:
            "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
          color: "#8139e7",
        },
        {
          question: "Can I book prasad for special occasions?",
          answer:
            "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
          color: "#8139e7",
        },
      ],
      sectionTitle: "Online Prasad Booking Service",
      metaTitle: "Online Prasad Booking - Receive Divine Blessings at Home",
      metaDescription:
        "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
      cannonicalLink: "https://www.myomnamo.com/services/online-prasad-booking",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",

        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Online Prasad Booking",
            item: "https://www.myomnamo.com/services/online-prasad-booking",
          },
        ],
      },
      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Online Prasad Booking - Receive Divine Blessings at Home",
        url: "https://www.myomnamo.com/services/online-prasad-booking",
        description:
          "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Which temples' prasad can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
            },
          },
          {
            "@type": "Question",
            name: "How long does delivery take?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
            },
          },
          {
            "@type": "Question",
            name: "Is the prasad prepared hygienically?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book prasad for special occasions?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
            },
          },
        ],
      },
      metaData: {
        title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
        description:
          "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/e-store",
        siteName: "Myomnamo",
        locale: "en_IN",
      },

      mainContent:
        "Book your sacred prasad online with Myomnamo and receive divine blessings at home. Choose fr.om famous temples like Tirupati Balaji, Shirdi Sai Baba, and Ayodhya. Select your preferred date, meal time, and the number of coupons needed. Each prasad is prepared with devotion and love, bringing the temple's spiritual essence to your doorstep. Enjoy the taste of tradition and the comfort of god's grace without leaving your home. Order now and feel the divine connection.",
    },
    {
      headerName: "Book Online Puja Services",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Book Online Puja Services",
      route: "/services/book-puja",
      serviceBannerImg: PujaBookingBannerImg,
      sectionTitle: "Book Online Puja Services",
      serviceName: "online-puja-services",
      howItWorksMainHeading: "Book Online Puja Services with Myomnamo",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Puja",
          howItWorksDesc:
            "Select from our sacred online pujas and book a skilled pandit for virtual rituals. Schedule your puja at least 2 days in advance.  ",
        },
        {
          howItWorksTitle: "Personalize & Confirm",
          howItWorksDesc:
            "Share your details and intentions for the puja. Receive a confirmation with samagri guidance and live puja timing. ",
        },
        {
          howItWorksTitle: "Witness & Receive Blessings ",
          howItWorksDesc:
            "Join the virtual puja from home, watch the rituals live, and receive divine blessings directly from our experienced pandits. ",
        },
      ],
      testimonials: [
        {
          Desc: "I booked a Satyanarayan Puja through My OmNamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
          name: "Rajesh Singh",
          location: "Delhi",
        },
        {
          Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, My OmNamo.",
          name: "Priya Mane",
          location: "Nashik",
        },
        {
          Desc: "I needed a Navagraha Shanti puja, and My OmNamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
          name: "Amit Kapoor",
          location: "Mumbai",
        },
        {
          Desc: "Booking an online puja was very easy. The communication from Myomnamo was clear, and everything was done with respect.",
          name: "Deepa Naik",
          location: "Kolhapur",
        },
        {
          Desc: "This is a great option for people living far from temples. I’m glad I found it through Myomnamo.",
          name: "Vishal Gokhale",
          location: "Amravati",
        },
      ],
      FaqObj: [
        {
          question: "How does online puja work?",
          answer:
            "You book a puja, our pandit performs it virtually with proper rituals. You can watch live and receive blessings from anywhere. No physical presence is needed.",
          color: "#ffa415",
        },
        {
          question: "Can I customize the puja for my needs?",
          answer:
            "Yes, share your specific wishes during booking. Our pandits tailor the puja accordingly, whether for health, success, or other spiritual purposes. ",
          color: "#fc5528",
        },
        {
          question: "Do I need to arrange puja items?",
          answer:
            "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
          color: "#8139e7",
        },
        {
          question: "Is online puja as effective as offline?",
          answer:
            " Absolutely. The power of puja depends on devotion and proper rituals. Our expert pandits ensure authenticity, making it equally sacred and effective.",
          color: "#8139e7",
        },
      ],
      metaTitle:
        "Book Online Puja Services - Virtual Rituals with Expert Pandits",
      metaDescription:
        "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
      cannonicalLink: "https://www.myomnamo.com/services/online-puja-services",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-booking",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Book Puja Online - Experienced Pandits for All Ceremonies",
        url: "https://www.myomnamo.com/services/puja-booking",
        description:
          "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What types of puja’s can I book?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book recurring pujas?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
            },
          },
          {
            "@type": "Question",
            name: "Are the pandits experienced and qualified?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
            },
          },
          {
            "@type": "Question",
            name: "Can I book a puja for a temple or home location?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can book a puja for your home, temple, or any preferred location.",
            },
          },
          {
            "@type": "Question",
            name: "Do you offer online puja services?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer virtual pujas where pandits perform rituals online.",
            },
          },
        ],
      },
      metaData: {
        title:
          "Book Online Puja Services - Virtual Rituals with Expert Pandits",
        description:
          "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-booking",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Book online puja services with Myomnamo and connect with divine blessings from your home. Our trusted and experienced pandits perform puja virtually, ensuring authenticity and devotion. We provide sacred puja samagri and guide you through the setup for a seamless spiritual experience. Whether it's for peace, prosperity, or special occasions, let us help you fulfill your prayers with heartfelt rituals. Experience the power of tradition, no matter where you are. Start your spiritual journey today. Book your online puja now.",
    },
    {
      headerName: "Bhakti Puja kit ",
      Imgabout1: About1,
      Imgabout2: panditBooking,
      tagLine: "Bhakti Kit Details",
      route: "/services/puja-kit",
      serviceBannerImg: LandingPujaKit,
      sectionTitle: "Complete Puja Samagri Kit",
      serviceName: "puja-kit-services",
      howItWorksMainHeading: "Book a Puja Kit Samagri with Myomnamo",
      howItWorks: [
        {
          howItWorksTitle: "Choose Your Subscription",
          howItWorksDesc:
            "Pick a plan that fits you: monthly, quarterly, or yearly and book your puja kit easily online in just a few steps",
        },
        {
          howItWorksTitle: "Personalize & Confirm",
          howItWorksDesc:
            "Share your delivery details and preferences. Receive confirmation, along with a premium wooden box in select plans",
        },
        {
          howItWorksTitle: "Receive & Renew ",
          howItWorksDesc:
            "Get fresh, high-quality samagri delivered to your door. Quarterly and longer plans include monthly ingredient refills for your convenience.",
        },
      ],
      testimonials: [
        {
          Desc: "The puja kit had everything I needed. It was neat and made the puja very easy. Myomnamo thought it through.",
          name: "Laxmi Karale",
          location: "Jalgaon",
        },
        {
          Desc: "Great quality items. Helped me perform all rituals without running to the market.",
          name: "Shrikant Mule",
          location: "Ahilyanagar",
        },
        {
          Desc: "Ordered the kit last minute, but it arrived on time. Very helpful service from Myomnamo.",
          name: "Manasi Gokhale",
          location: "Mumbai",
        },
        {
          Desc: "A complete kit for anyone who wants to do puja at home properly. Thank you Myomnamo.",
          name: "Rahul Pawaskar",
          location: "Ratnagiri",
        },
      ],
      FaqObj: [
        {
          question: " What are the ingredients in the puja kit?",
          answer:
            "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
          color: "#ffa415",
        },
        {
          question: "How often can I get the puja kit delivered?",
          answer:
            "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
          color: "#fc5528",
        },
        {
          question: "Do I need to arrange puja items?",
          answer:
            "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
          color: "#8139e7",
        },
        {
          question: "Are the kits affordable?",
          answer:
            "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
          color: "#8139e7",
        },
        {
          question: "Can I change my subscription later?",
          answer:
            "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
          color: "#8139e7",
        },
      ],
      metaTitle: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
      metaDescription:
        "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
      cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
      breadcrumbSchema: {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.myomnamo.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Puja Booking",
            item: "https://www.myomnamo.com/services/puja-kit-services",
          },
        ],
      },

      webpageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
        url: "https://www.myomnamo.com/services/puja-kit-services",
        description:
          "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
        publisher: {
          "@type": "Organization",
          name: "Myomnamo",
        },
      },

      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: " What are the ingredients in the puja kit ?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
            },
          },
          {
            "@type": "Question",
            name: " How often can I get the puja kit delivered ?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
            },
          },
          {
            "@type": "Question",
            name: "Are the kits affordable?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
            },
          },
          {
            "@type": "Question",
            name: "Can I change my subscription later?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
            },
          },
        ],
      },
      metaData: {
        title: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
        description:
          "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
        image: "https://www.myomnamo.com/assets/images/new/logo.png",
        url: "https://www.myomnamo.com/services/puja-kit-services",
        siteName: "Myomnamo",
        locale: "en_IN",
      },
      mainContent:
        "Get complete puja kits delivered to your doorstep on a monthly, quarterly, or yearly basis at an affordable price. Each kit includes all the necessary items you need for your daily or special rituals, saving you time and effort. Stay connected to your traditions with easy and convenient subscriptions that suit your needs. Trust Myomnamo to make your puja simple and stress-free, so you can focus on your devotion with peace of mind.",
    },
  ]);

  useEffect(() => {
    if (Number(selectedLanguageID) === langID?.Marathi) {
      setData((prev) => [
        {
          headerName: "पंडित बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "मंदिर पूजांसह दैवीत्वाचा अनुभव घ्या",
          route: "/services/book-puja",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "आपल्या पूजेसाठी अनुभवी पंडित बुक करा",
          serviceName: "puja-booking",
          howItWorksMainHeading: "दैवी आशीर्वादाकडे सहज वाटचाल",
          howItWorks: [
            {
              howItWorksTitle: "आपला सोहळा निवडा",
              howItWorksDesc:
                "लग्न, गृहप्रवेश, नामकरण किंवा कोणतीही विशेष पूजा – तुम्हाला हवी ती निवडा.",
            },
            {
              howItWorksTitle: "आपली पूजा बुक करा",
              howItWorksDesc:
                "आमचे अनुभवी पंडित प्रत्येक विधी श्रद्धेने, भक्तीने आणि वेदशास्त्रानुसार पार पाडतात.",
            },
            {
              howItWorksTitle: "पवित्र वातावरणाचा अनुभव घ्या",
              howItWorksDesc:
                "पंडितजी काळजीपूर्वक तुमचा सोहळा पार पाडतात. दैवी ऊर्जा अनुभवा, श्रद्धेशी नाते जोडा आणि आरोग्य, सुख व समृद्धीचे आशीर्वाद मिळवा.",
            },
          ],
          testimonials: [
            {
              Desc: "मी सत्यानारायण पूजा Myomnamo द्वारे बुक केली होती आणि सर्व व्यवस्था उत्तम प्रकारे करण्यात आल्या. पंडित ज्ञानी, वेळेवर आणि भक्तिभावाने विधी करणारे होते. खूपच समाधानकारक अनुभव.",
              name: "राजेश सिंह",
              location: "दिल्ली",
            },
            {
              Desc: "माझा गृहप्रवेश सोहळा अतिशय सुंदर झाला. पंडित वेळेवर आले आणि सर्व पूजासामग्रीसोबत आले. संपूर्ण प्रक्रिया अत्यंत सुरळीत आणि मंगलमय होती. धन्यवाद, Myomnamo.",
              name: "प्रिया माने",
              location: "नाशिक",
            },
            {
              Desc: "मला नवग्रह शांती पूजा हवी होती आणि Myomnamo मुळे ती खूप सोपी झाली! मंत्रोच्चार, विधी आणि व्यवस्था सर्व उत्तम रीतीने पार पडले. हा खरा दैवी अनुभव होता.",
              name: "अमित कपूर",
              location: "मुंबई",
            },
            {
              Desc: "नवरात्रीत मी माझ्या घरी पूजा आयोजित केली आणि Myomnamo ने सर्व सोय केली. संपूर्ण प्रक्रिया सोपी होती आणि पंडितांनी सर्व विधी शास्त्रशुद्ध केले.",
              name: "राजेश कुलकर्णी",
              location: "नाशिक",
            },
          ],
          FaqObj: [
            {
              question: "मी कोणकोणत्या पूजेसाठी बुकिंग करू शकतो?",
              answer:
                "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधी बुक करू शकता.",
              color: "#ffa415",
            },
            {
              question: "मी वारंवार पूजेसाठी बुकिंग करू शकतो का?",
              answer:
                "नक्कीच! तुम्ही दैनंदिन, साप्ताहिक किंवा अनेक दिवस चालणाऱ्या पूजेसाठी बुक करू शकता.",
              color: "#fc5528",
            },
            {
              question: "पंडित अनुभवी आणि पात्र आहेत का?",
              answer:
                "होय, आमचे सर्व पंडित अनुभवी, प्रशिक्षित असून योग्य वेदपरंपरेनुसार विधी करतात.",
              color: "#8139e7",
            },
            {
              question: "मी मंदिरात किंवा घरी पूजा बुक करू शकतो का?",
              answer:
                "होय, तुम्ही घरी, मंदिरात किंवा इच्छित ठिकाणी पूजेचे बुकिंग करू शकता.",
              color: "#8139e7",
            },
            {
              question: "तुम्ही ऑनलाइन पूजेची सुविधा देता का?",
              answer:
                "होय, आम्ही ऑनलाइन पूजा देखील करतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
              color: "#8139e7",
            },
          ],
          metaTitle: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
          metaDescription:
            "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्यपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "मी कोणकोणत्या पूजेसाठी बुकिंग करू शकतो?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधी बुक करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "मी वारंवार पूजेसाठी बुकिंग करू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "नक्कीच! तुम्ही दैनंदिन, साप्ताहिक किंवा अनेक दिवस चालणाऱ्या पूजेसाठी बुक करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "पंडित अनुभवी आणि पात्र आहेत का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आमचे सर्व पंडित अनुभवी, प्रशिक्षित असून योग्य वेदपरंपरेनुसार विधी करतात.",
                },
              },
              {
                "@type": "Question",
                name: "मी मंदिरात किंवा घरी पूजा बुक करू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, तुम्ही घरी, मंदिरात किंवा इच्छित ठिकाणी पूजेचे बुकिंग करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "तुम्ही ऑनलाइन पूजेची सुविधा देता का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आम्ही ऑनलाइन पूजा देखील करतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा बुक करा - सर्व विधीसाठी अनुभवी पंडित",
            description:
              "लग्न, गृहप्रवेश किंवा कोणत्याही पूजेसाठी पंडित बुक करा. पूजेचे विधी श्रद्धा, भक्ती आणि परंपरेनुसार पार पाडले जातील. आजच आपले बुकिंग सुरू करा!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "अनुभवी पंडितांच्या मार्गदर्शनाने तुमचे खास क्षण पवित्र बनवा. मग ते लग्न असो, गृहप्रवेश, नामकरण किंवा कोणतीही पूजा – पंडित प्रत्येक विधी श्रद्धा आणि भक्तीने पार पाडतात. त्यांचे परंपरांचे ज्ञान तुमच्या घरी शांती आणि सकारात्मकता आणते. छोट्या घरगुती सोहळ्यांपासून मोठ्या कार्यक्रमांपर्यंत, आम्ही तुमच्या समारंभात मंगलमय वातावरण निर्माण करतो. पूजेच्या विधींमुळे श्रद्धेशी नाते जोडले जाते आणि आरोग्य, सुख, समृद्धीचे आशीर्वाद लाभतात. अनुभवी पंडिताच्या मार्गदर्शनाने प्रत्येक सोहळा खास आणि संस्मरणीय बनवा.",
        },
        {
          headerName: "दैनिक पंडित बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: DailyPooja,
          tagLine: "मंदिर पूजांसह दैवीत्वाचा अनुभव घ्या",
          sectionTitle: "तुमच्या सोयीप्रमाणे दैनंदिन पूजेसाठी पंडित बुक करा",
          serviceBannerImg: DailyPujaBookingBannerImg,
          serviceName: "daily-puja-booking",
          howItWorksMainHeading:
            "तुमच्या सोयीप्रमाणे दैनंदिन पूजेसाठी पंडित बुक करा",
          howItWorks: [
            {
              howItWorksTitle: "आपला विधी निवडा",
              howItWorksDesc:
                "गणपती पूजा, नवरात्री आरती किंवा साधी सकाळची प्रार्थना – तुम्हाला हवी ती सेवा निवडा. आम्ही तुम्हाला अनुभवी पंडिताशी जोडू.",
            },
            {
              howItWorksTitle: "आपला वेळ ठरवा",
              howItWorksDesc:
                "तुमच्या दिनचर्येनुसार तारीख आणि वेळ निवडा. पंडित सकाळी आणि संध्याकाळी उपलब्ध आहेत, त्यामुळे तुम्ही सोयीप्रमाणे पूजा ठरवू शकता.",
            },
            {
              howItWorksTitle: "दैवी आशीर्वादाचा अनुभव घ्या",
              howItWorksDesc:
                "तुमचे पंडित सर्व आवश्यक पूजासामग्रीसह येतात. तुमच्या जागेत शांती, सकारात्मकता आणि दैवी ऊर्जा अनुभवा.",
            },
          ],
          testimonials: [
            {
              Desc: "मी दैनंदिन गणेश पूजेसाठी बुकिंग केले आणि त्यामुळे माझ्या घरी खूप सकारात्मकता आली आहे. पंडित भक्तिभावाने विधी करतात आणि सर्व काही व्यवस्थित होते. मी खूप आभारी आहे.",
              name: "अंजली राजपूत",
              location: "मुंबई",
            },
            {
              Desc: "माझ्या कुटुंबाला दैनंदिन शिव अभिषेक हवा होता आणि Myomnamo मुळे ते अगदी सोपे झाले. पंडित वेळेवर येतात, ज्ञानी आहेत आणि योग्य वेदपरंपरेनुसार पूजा करतात. अत्यंत शिफारसीय.",
              name: "सुरेश काळे",
              location: "नाशिक",
            },
            {
              Desc: "मी मासिक लक्ष्मी पूजेची सेवा घेतली आणि अनुभव खूप छान होता. प्रार्थना मनापासून केल्या जातात, ज्यामुळे घरात शांती आणि समृद्धी येते.",
              name: "मीरा सावंत",
              location: "बंगळूर",
            },
            {
              Desc: "विश्वास ठेवणाऱ्या पण व्यस्त असणाऱ्या लोकांसाठी Myomnamo ची ही खूप छान सोय आहे.",
              name: "चेतन पवार",
              location: "चंद्रपूर",
            },
            {
              Desc: "दररोज सकाळी मला पूजेबद्दल अपडेट मिळते. दिवसाची सुरुवात सकारात्मकतेने होते. Myomnamo चे आभार.",
              name: "अर्जुन शिंदे",
              location: "जळगाव",
            },
          ],
          FaqObj: [
            {
              question: "दैनंदिन पूजा बुकिंग सेवा म्हणजे काय?",
              answer:
                "यामुळे तुम्ही घरात किंवा मंदिरात दैनंदिन पूजेसाठी पंडित बुक करू शकता.",
              color: "#ffa415",
            },
            {
              question: "मी माझ्या विधीसाठी पंडित कसा बुक करू?",
              answer:
                "तुम्ही सहजपणे ऑनलाइन पंडित बुक करू शकता – तुमचा विधी निवडा, तारीख ठरवा आणि बुकिंग कन्फर्म करा.",
              color: "#fc5528",
            },
            {
              question: "मी विशिष्ट पंडित निवडू शकतो का?",
              answer:
                "होय, उपलब्धतेनुसार आणि तुमच्या पसंतीच्या भाषेनुसार किंवा परंपरेनुसार पंडित निवडू शकता.",
              color: "#8139e7",
            },
            {
              question: "मी रोज ठराविक वेळी पूजा ठरवू शकतो का?",
              answer:
                "होय, तुम्ही तुमच्या सोयीप्रमाणे रोज ठराविक वेळी पूजा आयोजित करू शकता.",
              color: "#8139e7",
            },
            {
              question: "मी व्हर्च्युअल दैनंदिन पूजा बुक करू शकतो का?",
              answer:
                "होय, आम्ही ऑनलाइन पूजांची सुविधा देतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
              color: "#8139e7",
            },
          ],
          route: "/services/daily-booking",
          metaTitle:
            "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
          metaDescription:
            "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
          cannonicalLink:
            "https://www.myomnamo.com/services/daily-puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्यपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "दैनंदिन पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/daily-puja-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            description:
              "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "दैनंदिन पूजा बुकिंग सेवा म्हणजे काय?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "यामुळे तुम्ही घरात किंवा मंदिरात दैनंदिन पूजेसाठी पंडित बुक करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "मी माझ्या विधीसाठी पंडित कसा बुक करू?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "तुम्ही सहजपणे ऑनलाइन पंडित बुक करू शकता – तुमचा विधी निवडा, तारीख ठरवा आणि बुकिंग कन्फर्म करा.",
                },
              },
              {
                "@type": "Question",
                name: "मी विशिष्ट पंडित निवडू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, उपलब्धतेनुसार आणि तुमच्या पसंतीच्या भाषेनुसार किंवा परंपरेनुसार पंडित निवडू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "मी रोज ठराविक वेळी पूजा ठरवू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, तुम्ही तुमच्या सोयीप्रमाणे रोज ठराविक वेळी पूजा आयोजित करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "मी व्हर्च्युअल दैनंदिन पूजा बुक करू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आम्ही ऑनलाइन पूजांची सुविधा देतो जिथे पंडित विधी आभासी पद्धतीने करतात.",
                },
              },
            ],
          },
          metaData: {
            title:
              "दैनंदिन पूजा बुकिंग ऑनलाइन - सकाळ व संध्याकाळच्या विधीसाठी विश्वासार्ह पंडित",
            description:
              "तुमच्या दैनंदिन पूजेसाठी अनुभवी पंडित बुक करा. तुमचा विधी निवडा, वेळ ठरवा आणि घरात सहजपणे दैवी आशीर्वाद आमंत्रित करा. आजच सकाळी किंवा संध्याकाळी बुक करा.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "घरात किंवा कार्यक्रमात दैनंदिन पूजा करण्यासाठी पंडित हवा आहे का? अनुभवी पंडित दररोज सकाळी आणि संध्याकाळी उपलब्ध आहेत आणि ते भक्तिभावाने तुमचा आध्यात्मिक अनुभव मार्गदर्शन करतील. मग ते दहा दिवसांचे गणपती पूजन असो, नवरात्री आरती असो किंवा अनेक दिवस चालणारा सोहळा – प्रत्येक टप्पा शास्त्रशुद्ध पार पाडला जातो. मंत्रोच्चारापासून आरतीपर्यंत सर्व विधी योग्य प्रकारे केले जातात. तुमच्या घरात दररोज शांती, सकारात्मकता आणि दैवी आशीर्वाद आणा. अनुभवी पंडिताच्या मार्गदर्शनाखाली दररोज दैवी आशीर्वादाचा अनुभव घ्या.",
        },
        {
          headerName: "पूजा बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "पूजांद्वारे दैवीत्वाचा स्वीकार करा",
          route: "/puja-book",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "तुमच्या अध्यात्मिक क्षणांसाठी पूजा बुक करा",
          serviceName: "pujas",
          howItWorksMainHeading: "दैवी कृपेचा सहज मार्ग",
          howItWorks: [
            {
              howItWorksTitle: "तुमचा सोहळा निवडा",
              howItWorksDesc:
                "लग्न, गृहप्रवेश, नामकरण किंवा कोणतीही विशेष पूजा – तुम्हाला हवी ती पूजा निवडा.",
            },
            {
              howItWorksTitle: "तुमची पूजा बुक करा",
              howItWorksDesc:
                "आमचे अनुभवी पंडित प्रत्येक विधी श्रद्धा, भक्ती आणि शास्त्रोक्त पद्धतीने पार पाडतात.",
            },
            {
              howItWorksTitle: "पवित्र वातावरणाचा अनुभव घ्या",
              howItWorksDesc:
                "पंडितजी तुमचा सोहळा आदराने पार पाडतात. दैवी ऊर्जा अनुभवा, श्रद्धेशी जोडले जा आणि आरोग्य, आनंद व समृद्धीचे आशीर्वाद मिळवा.",
            },
          ],
          testimonials: [
            {
              Desc: "मी सत्यनारायण पूजा Myomnamo मार्फत बुक केली आणि सगळं अगदी छानपणे व्यवस्थापित झालं. पंडितजी विद्वान, वेळेवर आणि पूर्ण भक्तिभावाने पूजा पार पाडली. अत्यंत शिफारसीय.",
              name: "राजेश सिंह",
              location: "दिल्ली",
            },
            {
              Desc: "माझी गृहप्रवेश पूजा अत्यंत सुंदररित्या झाली. पंडितजी वेळेवर आले आणि आवश्यक सामग्री घेऊन आले. संपूर्ण प्रक्रिया सुरळीत आणि मंगलमय झाली. धन्यवाद Myomnamo.",
              name: "प्रिया माने",
              location: "नाशिक",
            },
            {
              Desc: "मला नवग्रह शांती पूजा हवी होती आणि Myomnamo ने ती खूप सोपी केली! मंत्रोच्चार, विधी आणि तयारी अगदी अचूक झाली. खरोखरच दैवी अनुभव.",
              name: "अमित कपूर",
              location: "मुंबई",
            },
            {
              Desc: "Myomnamo ने मला नवरात्रीच्या काळात माझ्या घरी पूजा आयोजित करण्यात मदत केली. संपूर्ण प्रक्रिया सुरळीत झाली आणि पंडितजींनी सर्व विधी व्यवस्थित केले.",
              name: "राजेश कुलकर्णी",
              location: "नाशिक",
            },
          ],
          FaqObj: [
            {
              question: "मी कोणत्या प्रकारच्या पूजांचे बुकिंग करू शकतो?",
              answer:
                "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधींचे बुकिंग करू शकता.",
              color: "#ffa415",
            },
            {
              question: "मी वारंवार होणाऱ्या पूजांचे बुकिंग करू शकतो का?",
              answer:
                "होय! तुम्ही तुमच्या गरजेनुसार दररोज, आठवड्यातून किंवा अनेक दिवस चालणाऱ्या पूजांचे वेळापत्रक ठरवू शकता.",
              color: "#fc5528",
            },
            {
              question: "पंडितजी अनुभवी आणि पात्र आहेत का?",
              answer:
                "होय, आमचे सर्व पंडितजी अनुभवी, प्रशिक्षित आणि योग्य वेदिक पद्धतीने विधी पार पाडतात.",
              color: "#8139e7",
            },
            {
              question: "मी घर किंवा मंदिरासाठी पूजा बुक करू शकतो का?",
              answer:
                "होय, तुम्ही घर, मंदिर किंवा कोणत्याही पसंतीच्या ठिकाणी पूजा बुक करू शकता.",
              color: "#8139e7",
            },
            {
              question: "तुम्ही ऑनलाइन पूजा सेवा देता का?",
              answer:
                "होय, आम्ही आभासी पूजा सेवा देतो जिथे पंडितजी ऑनलाइन विधी पार पाडतात.",
              color: "#8139e7",
            },
          ],
          metaTitle: "ऑनलाइन पूजा बुक करा - सर्व सोहळ्यांसाठी अनुभवी पंडित",
          metaDescription:
            "लग्न, गृहप्रवेश किंवा कोणतीही पूजा बुक करा. अनुभवी पंडित श्रद्धा, भक्ती आणि परंपरेनुसार विधी पार पाडतील. आत्ताच तुमची पूजा बुकिंग सुरू करा!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्यपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा बुक करा - सर्व सोहळ्यांसाठी अनुभवी पंडित",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "लग्न, गृहप्रवेश किंवा कोणतीही पूजा बुक करा. अनुभवी पंडित श्रद्धा, भक्ती आणि परंपरेनुसार विधी पार पाडतील. आत्ताच तुमची पूजा बुकिंग सुरू करा!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "मी कोणत्या प्रकारच्या पूजांचे बुकिंग करू शकतो?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "तुम्ही गणपती पूजा, नवरात्री आरती, लक्ष्मी पूजा आणि इतर अनेक विधींचे बुकिंग करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "मी वारंवार होणाऱ्या पूजांचे बुकिंग करू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय! तुम्ही तुमच्या गरजेनुसार दररोज, आठवड्यातून किंवा अनेक दिवस चालणाऱ्या पूजांचे वेळापत्रक ठरवू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "पंडितजी अनुभवी आणि पात्र आहेत का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आमचे सर्व पंडितजी अनुभवी, प्रशिक्षित आणि योग्य वेदिक पद्धतीने विधी पार पाडतात.",
                },
              },
              {
                "@type": "Question",
                name: "मी घर किंवा मंदिरासाठी पूजा बुक करू शकतो का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, तुम्ही घर, मंदिर किंवा कोणत्याही पसंतीच्या ठिकाणी पूजा बुक करू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "तुम्ही ऑनलाइन पूजा सेवा देता का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आम्ही आभासी पूजा सेवा देतो जिथे पंडितजी ऑनलाइन विधी पार पाडतात.",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा बुक करा - सर्व सोहळ्यांसाठी अनुभवी पंडित",
            description:
              "लग्न, गृहप्रवेश किंवा कोणतीही पूजा बुक करा. अनुभवी पंडित श्रद्धा, भक्ती आणि परंपरेनुसार विधी पार पाडतील. आत्ताच तुमची पूजा बुकिंग सुरू करा!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "तुमचे विशेष क्षण एका अनुभवी पंडितांच्या मार्गदर्शनाने मंगलमय करा. लग्न, गृहप्रवेश, नामकरण किंवा कोणतीही पूजा असो, पंडितजी प्रत्येक विधी भक्तिभावाने व शास्त्रोक्त रीतीने पार पाडतात. त्यांच्या परंपरेच्या ज्ञानामुळे तुमच्या घरी किंवा सोहळ्यात शांतता आणि सकारात्मकता नांदते. घरगुती लहान पूजांपासून मोठ्या कार्यक्रमांपर्यंत, आम्ही तुमच्या सोहळ्यात श्रद्धा आणि मंगल वातावरण आणतो. विधीमुळे तुमची श्रद्धेशी नाळ जोडली जाते आणि आरोग्य, आनंद व समृद्धीचे आशीर्वाद मिळतात. अनुभवी पंडितांसोबत प्रत्येक समारंभ खास आणि अविस्मरणीय बनवा.",
        },
        {
          headerName: "राशीभविष्य वाचन",
          Imgabout1: About1,
          Imgabout2: Horoscope,
          tagLine: "मंदिरातील पूजेद्वारे दैवीत्वाला आलिंगन द्या",
          route: "/basic-details",
          serviceBannerImg: HoroscopeBannerImg,
          cannonicalLink: "https://www.myomnamo.com/services/horoscope",
          serviceName: "horoscope",
          sectionTitle: "तुमच्या ताऱ्यांचे रहस्य जाणून घ्या",
          howItWorksMainHeading: "आमचे राशीभविष्य वाचन कसे कार्य करते",
          howItWorks: [
            {
              howItWorksTitle: "तुमची रास निवडा",
              howItWorksDesc:
                "तुमच्या जीवनाबद्दल, भावना आणि भविष्यातील शक्यता याबद्दल वैयक्तिकृत वाचनासाठी तुमची रास निवडा.",
            },
            {
              howItWorksTitle: "तुरंत मार्गदर्शन मिळवा",
              howItWorksDesc:
                "प्रेम, करिअर आणि कल्याण यावर तपशीलवार मार्गदर्शनासह दैनंदिन, साप्ताहिक किंवा वार्षिक राशीभविष्य पाहा.",
            },
            {
              howItWorksTitle: "तुमच्या मार्गाला आलिंगन द्या",
              howItWorksDesc:
                "तुमच्या राशीभविष्याचा सल्ला वापरून निर्णय घ्या, शुभ दिवस शोधा आणि आयुष्यात आनंद व संतुलन आणा.",
            },
          ],
          testimonials: [
            {
              Desc: "मायओमनामो कडून मिळालेला वैयक्तिक राशीभविष्य अहवाल माझ्या करिअर आणि वैयक्तिक आयुष्याबद्दल खूप गोष्टी समजून घेण्यास मदत झाला. अतिशय उपयुक्त.",
              name: "अमित डुंबरे",
              location: "पुणे",
            },
            {
              Desc: "मला आधी ज्योतिषशास्त्रात फारसा रस नव्हता, पण मायओमनामोच्या साप्ताहिक मार्गदर्शनाने खरंच मला चांगले निर्णय घेण्यास मदत झाली.",
              name: "वैशाली ठाकूर",
              location: "नागपूर",
            },
            {
              Desc: "मायओमनामोचे राशीभविष्य वाचन तपशीलवार आणि समजायला सोपे होते. ते जास्त तांत्रिक नव्हते आणि व्यावहारिक सूचना दिल्या.",
              name: "रोहित पंसरे",
              location: "नाशिक",
            },
            {
              Desc: "मी मायओमनामोचे दैनंदिन राशीभविष्य वाचायला सुरुवात केली आणि प्रत्येक सकाळी मला स्पष्टता व लक्ष मिळते. ते खूप अचूक आणि अर्थपूर्ण वाटते.",
              name: "प्राची केळकर",
              location: "मुंबई",
            },
          ],
          FaqObj: [
            {
              question: "मंदिरातील पूजा सेवा काय आहे?",
              answer:
                "आमची सेवा तुम्हाला ऑनलाइन मंदिर पूजा बुक करण्याची सुविधा देते, ज्यामुळे प्रक्रिया सोपी आणि अडथळामुक्त होते.",
              color: "#ffa415",
            },
            {
              question: "मी पूजा कशी बुक करू?",
              answer:
                "तुम्ही ऑनलाइन किंवा मंदिरात पूजा बुक करू शकता. पूजा प्रकार, तारीख आणि वेळ निवडा.",
              color: "#fc5528",
            },
            {
              question: "कोणत्या प्रकारच्या पूजाआरत्या उपलब्ध आहेत?",
              answer:
                "आम्ही वाढदिवस, वाढदिवस, सण, वैयक्तिक प्रार्थना आणि विशेष समारंभांसाठी पूजा देतो.",
              color: "#8139e7",
            },
            {
              question: "विशेष किंवा खासगी पूजा उपलब्ध आहेत का?",
              answer:
                "होय, काही मंदिरांमध्ये वैयक्तिक विधींनी युक्त खासगी पूजा उपलब्ध आहेत.",
              color: "#8139e7",
            },
          ],
          metaTitle: "राशीभविष्य वाचन - तुमचे भविष्य जाणून घ्या",
          metaDescription:
            "प्रेम, करिअर आणि जीवनातील निर्णयांसाठी मार्गदर्शन मिळवा. तुमच्या राशीनुसार दैनंदिन, साप्ताहिक किंवा वार्षिक राशीभविष्य जाणून घ्या. आजच सल्लामसलत बुक करा.",
          canonicalLink: "https://www.myomnamo.com/services/horoscope",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्यपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "राशीभविष्य",
                item: "https://www.myomnamo.com/services/horoscope",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "राशीभविष्य वाचन - तुमचे भविष्य जाणून घ्या",
            url: "https://www.myomnamo.com/services/horoscope",
            description:
              "प्रेम, करिअर आणि जीवनातील निर्णयांसाठी मार्गदर्शन मिळवा. तुमच्या राशीनुसार दैनंदिन, साप्ताहिक किंवा वार्षिक राशीभविष्य जाणून घ्या. आजच सल्लामसलत बुक करा.",
            publisher: {
              "@type": "Organization",
              name: "मायओमनामो",
            },
          },
          metaData: {
            title: "राशीभविष्य वाचन - तुमचे भविष्य जाणून घ्या",
            description:
              "प्रेम, करिअर आणि जीवनातील निर्णयांसाठी मार्गदर्शन मिळवा. तुमच्या राशीनुसार दैनंदिन, साप्ताहिक किंवा वार्षिक राशीभविष्य जाणून घ्या. आजच सल्लामसलत बुक करा.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/horoscope",
            siteName: "मायओमनामो",
            locale: "mr_IN",
          },
          mainContent:
            "सोप्या राशीभविष्य वाचनाद्वारे तुमचे भविष्य जाणून घ्या. तुमच्या दिवस, आठवडा किंवा वर्षाबद्दल त्वरित माहिती मिळवा. प्रेम, काम, आरोग्य आणि इतर बाबींवर अंतर्दृष्टी मिळवा. मोठा निर्णय घ्यायचा असेल किंवा फक्त कुतूहल असेल तरी राशीभविष्य तुम्हाला योग्य मार्गदर्शन करेल. शुभ दिवस, उपयुक्त सल्ले आणि आयुष्यात अधिक आनंद आणण्याचे मार्ग शोधा. उज्ज्वल भविष्याकडे ताऱ्यांनी तुम्हाला मार्गदर्शन करू द्या.",
        },
        {
          headerName: "ऑनलाइन पूजा सामान स्टोअर",
          Imgabout1: About1,
          Imgabout2: Ecart,
          tagLine: "मंदिरी पूजा सोबत दैवी अनुभूती घ्या",
          serviceBannerImg: EstoreBannerImg,
          route: "/my-store",
          serviceName: "e-store",
          howItWorksMainHeading: "ई-स्टोअरसह पूजा खरेदी सोपी",
          howItWorks: [
            {
              howItWorksTitle: "ब्राउझ करा आणि निवडा",
              howItWorksDesc:
                "आमच्या विस्तृत पूजा सामान श्रेणीमध्ये शोधा. आपल्या आध्यात्मिक गरजेनुसार पूजा सामान किंवा संपूर्ण पूजा किट निवडा.",
            },
            {
              howItWorksTitle: "ऑर्डर करा आणि पेमेंट करा",
              howItWorksDesc:
                "आपली निवडलेली वस्तू कार्टमध्ये टाका, सुरक्षितपणे चेकआउट करा आणि सोयीस्कर पेमेंट पर्याय निवडा.",
            },
            {
              howItWorksTitle: "प्राप्त करा आणि पूजा करा",
              howItWorksDesc:
                "आपली ऑर्डर दरवाजापर्यंत मिळवा. आपले विधी शांततेने पार पाडा, सर्व वस्तू तयार आणि पवित्र असतील.",
            },
          ],
          testimonials: [
            {
              Desc: "मी लक्ष्मी मूर्ती आणि रुद्राक्ष माळ ऑर्डर केली, आणि गुणवत्तेने मला आनंद दिला. वस्तू व्यवस्थित पॅक केल्या होत्या आणि वेळेवर पोहचल्या.",
              name: "पूजा मोरे",
              location: "पुणे",
            },
            {
              Desc: "मी संपूर्ण पूजा किट खरेदी केले, ज्यामुळे माझे विधी सोपे झाले. सर्व वस्तू प्रामाणिक आणि पवित्र होत्या. अत्यंत शिफारस.",
              name: "विकास राठी",
              location: "बंगलोर",
            },
            {
              Desc: "मी ई-स्टोअरवर अगरबत्ती आणि शंख घेतले. वितरण जलद होते आणि पॅकेजिंग उत्कृष्ट होते. पुन्हा खरेदी करीन.",
              name: "मीनल शिंदे",
              location: "जयपूर",
            },
            {
              Desc: "मायओमनमोच्या ई-स्टोअरवर खरेदी करणे सोपे आणि सुविधाजनक होते. मला सर्व पूजा वस्तू एका ठिकाणी मिळाल्या.",
              name: "सागर शिंदे",
              location: "मुंबई",
            },
          ],
          FaqObj: [
            {
              question: "आपण कोणती उत्पादने ऑफर करता?",
              answer:
                "आम्ही पूजा सामान, संपूर्ण किट, मूर्ती, अगरबत्ती, फुले आणि दैनंदिन विधीसाठी किंवा विशेष सोहळ्यांसाठी आवश्यक सर्व वस्तू उपलब्ध करतो.",
              color: "#ffa415",
            },
            {
              question: "आपण जलद वितरण ऑफर करता का?",
              answer:
                "होय! आम्ही सुनिश्चित करतो की आपल्याला वेळेवर वस्तू मिळतील जेणेकरून आपली पूजा किंवा उत्सव वेळेवर होईल.",
              color: "#fc5528",
            },
            {
              question: "उत्पादने प्रामाणिक आणि पवित्र आहेत का?",
              answer:
                "होय, आमची उत्पादने विश्वसनीय विक्रेत्यांकडून मिळवली जातात आणि अनेक वस्तू आध्यात्मिक दृष्ट्या पवित्र असतात.",
              color: "#8139e7",
            },
          ],
          sectionTitle: "आपले एकमेव ऑनलाइन ई-स्टोअर",
          metaTitle:
            "ऑनलाइन पूजा सामान स्टोअर - मायओमनमोवर पूजा वस्तू खरेदी करा",
          metaDescription:
            "मायओमनमोवर प्रामाणिक पूजा सामान आणि वस्तू ऑनलाइन खरेदी करा. सर्व प्रकारच्या विधी आणि सोहळ्यांसाठी वस्तू मिळवा. जलद वितरण आणि विश्वसनीय गुणवत्ता.",
          cannonicalLink: "https://www.myomnamo.com/services/e-store",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुखपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा सामान स्टोअर",
                item: "https://www.myomnamo.com/services/e-store",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा सामान स्टोअर - मायओमनमोवर पूजा वस्तू खरेदी करा",
            url: "https://www.myomnamo.com/services/e-store",
            description:
              "मायओमनमोवर प्रामाणिक पूजा सामान आणि वस्तू ऑनलाइन खरेदी करा. सर्व प्रकारच्या विधी आणि सोहळ्यांसाठी वस्तू मिळवा. जलद वितरण आणि विश्वसनीय गुणवत्ता.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "आपण कोणती उत्पादने ऑफर करता?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आम्ही पूजा सामान, संपूर्ण किट, मूर्ती, अगरबत्ती, फुले आणि दैनंदिन विधीसाठी किंवा विशेष सोहळ्यांसाठी आवश्यक सर्व वस्तू उपलब्ध करतो.",
                },
              },
              {
                "@type": "Question",
                name: "आपण जलद वितरण ऑफर करता का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय! आम्ही सुनिश्चित करतो की आपल्याला वेळेवर वस्तू मिळतील जेणेकरून आपली पूजा किंवा उत्सव वेळेवर होईल.",
                },
              },
              {
                "@type": "Question",
                name: "उत्पादने प्रामाणिक आणि पवित्र आहेत का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आमची उत्पादने विश्वसनीय विक्रेत्यांकडून मिळवली जातात आणि अनेक वस्तू आध्यात्मिक दृष्ट्या पवित्र असतात.",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा सामान स्टोअर - मायओमनमोवर पूजा वस्तू खरेदी करा",
            description:
              "मायओमनमोवर प्रामाणिक पूजा सामान आणि वस्तू ऑनलाइन खरेदी करा. सर्व प्रकारच्या विधी आणि सोहळ्यांसाठी वस्तू मिळवा. जलद वितरण आणि विश्वसनीय गुणवत्ता.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/e-store",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "घरबसल्या आपल्या पूजा गरजा पूर्ण करा. पूजा सामान, संपूर्ण पूजा किट, मूर्ती, अगरबत्ती आणि इतर वस्तू मिळवा. दैनंदिन पूजा किंवा विशेष उत्सवासाठी आवश्यक सर्व वस्तू एकत्र मिळवा. विविध दुकाने भेट देण्याची गरज नाही, फक्त ब्राउझ करा आणि वस्तू आपल्या दारावर पोहचवा. प्रत्येक सोहळा अर्थपूर्ण बनवा योग्य वस्तूंसह, पवित्र फुले आणि धार्मिक वस्तूंसह. आपल्या श्रद्धेला बळकटी द्या प्रत्येक आध्यात्मिक प्रसंगी योग्य वस्तूंसह.",
        },
        {
          headerName: "भक्ती पूजा किट",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "भक्ती किट माहिती",
          route: "/services/puja-kit",
          serviceBannerImg: LandingPujaKit,
          sectionTitle: "संपूर्ण पूजा सामान किट",
          serviceName: "puja-kit-services",
          howItWorksMainHeading: "मायओमनमो सोबत पूजा किट बुक करा",
          howItWorks: [
            {
              howItWorksTitle: "आपली सदस्यता निवडा",
              howItWorksDesc:
                "महिन्याचे, तिमाही किंवा वार्षिक योजना निवडा आणि काही सोप्या पावलांत आपल्या पूजा किटची ऑनलाइन बुकिंग करा.",
            },
            {
              howItWorksTitle: "वैयक्तिकृत करा आणि पुष्टी करा",
              howItWorksDesc:
                "आपले वितरण तपशील आणि प्राधान्ये शेअर करा. पुष्टी मिळवा आणि निवडलेल्या योजनांमध्ये प्रीमियम लाकडी बॉक्ससह किट मिळवा.",
            },
            {
              howItWorksTitle: "प्राप्त करा आणि नूतनीकरण करा",
              howItWorksDesc:
                "ताजे, उच्च प्रतीचे सामग्री आपल्या दारावर मिळवा. तिमाही व दीर्घकालीन योजना मासिक साहित्य भरण्यांसह येतात, ज्यामुळे आपल्याला सोयीस्कर राहते.",
            },
          ],
          testimonials: [
            {
              Desc: "या पूजा किटमध्ये मला हवे असलेले सर्व काही होते. किट व्यवस्थित होते आणि पूजा सोपी झाली. मायओमनमोने उत्तम विचार केला.",
              name: "लक्ष्मी करले",
              location: "जळगाव",
            },
            {
              Desc: "उत्पादनांची गुणवत्ता उत्तम होती. बाजारात धावण्याची गरज न करता सर्व विधी पार पाडता आले.",
              name: "श्रीकांत मुळे",
              location: "अहिल्यानगर",
            },
            {
              Desc: "किट शेवटच्या क्षणी ऑर्डर केले, पण वेळेवर पोहचले. मायओमनमोची सेवा खूप उपयुक्त होती.",
              name: "मानसी गोखले",
              location: "मुंबई",
            },
            {
              Desc: "जो कोणी घरबसल्या योग्य पूजा करायची इच्छा ठेवतो त्यासाठी संपूर्ण किट. धन्यवाद मायओमनमो.",
              name: "राहुल पावसकर",
              location: "रत्नगिरी",
            },
          ],
          FaqObj: [
            {
              question: "पुजा किटमध्ये कोणते साहित्य आहे?",
              answer:
                "प्रत्येक किटमध्ये दैनंदिन किंवा विशेष विधीसाठी आवश्यक सर्व साहित्य असते. सर्व वस्तू सोयीस्कर पॅक केल्या जातात जेणेकरून आपली पूजा सहज पार पडेल.",
              color: "#ffa415",
            },
            {
              question: "पुजा किट किती वेळा मिळू शकते?",
              answer:
                "आपण मासिक, तिमाही किंवा वार्षिक वितरण निवडू शकता. आपल्या पूजा सवयीला अनुरूप पर्याय निवडा.",
              color: "#fc5528",
            },
            {
              question: "मला स्वतः पूजा साहित्य व्यवस्थापित करावे लागेल का?",
              answer:
                "नाही, आम्ही सर्व पवित्र सामग्री प्रदान करतो. फक्त डिव्हाइस (फोन/लॅपटॉप) वापरून लाईव्ह सत्रात सामील व्हा आणि आध्यात्मिक सहभाग घ्या.",
              color: "#8139e7",
            },
            {
              question: "किट किफायतशीर आहेत का?",
              answer:
                "होय, किट्स बजेट-फ्रेंडली आहेत. जास्त खर्च न करता आपली आध्यात्मिक प्रथा चालू ठेवू शकता.",
              color: "#8139e7",
            },
            {
              question: "सदस्यता नंतर बदलता येईल का?",
              answer:
                "होय, आपली योजना कधीही बदलू किंवा अपडेट करू शकता. आपल्याला आवश्यकतेनुसार सदस्यता बदलणे सोपे आहे.",
              color: "#8139e7",
            },
          ],
          metaTitle: "पुजा किट सदस्यता – मासिक, तिमाही व वार्षिक योजना",
          metaDescription:
            "तुमच्या विधीसाठी आवश्यक सर्व सामग्रीसह तयार-उपयोग पूजा किट्स ऑर्डर करा. एक सोपी, भक्तीपूर्ण सेवा जी परंपरा आपल्या दारापर्यंत आणते.",
          cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुखपृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-kit-services",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "पुजा किट सदस्यता – मासिक, तिमाही व वार्षिक योजना",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            description:
              "तुमच्या विधीसाठी आवश्यक सर्व सामग्रीसह तयार-उपयोग पूजा किट्स ऑर्डर करा. एक सोपी, भक्तीपूर्ण सेवा जी परंपरा आपल्या दारापर्यंत आणते.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "पुजा किटमध्ये कोणते साहित्य आहे?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "प्रत्येक किटमध्ये दैनंदिन किंवा विशेष विधीसाठी आवश्यक सर्व साहित्य असते. सर्व वस्तू सोयीस्कर पॅक केल्या जातात जेणेकरून आपली पूजा सहज पार पडेल.",
                },
              },
              {
                "@type": "Question",
                name: "पुजा किट किती वेळा मिळू शकते?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आपण मासिक, तिमाही किंवा वार्षिक वितरण निवडू शकता. आपल्या पूजा सवयीला अनुरूप पर्याय निवडा.",
                },
              },
              {
                "@type": "Question",
                name: "किट किफायतशीर आहेत का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, किट्स बजेट-फ्रेंडली आहेत. जास्त खर्च न करता आपली आध्यात्मिक प्रथा चालू ठेवू शकता.",
                },
              },
              {
                "@type": "Question",
                name: "सदस्यता नंतर बदलता येईल का?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "होय, आपली योजना कधीही बदलू किंवा अपडेट करू शकता. आपल्याला आवश्यकतेनुसार सदस्यता बदलणे सोपे आहे.",
                },
              },
            ],
          },
          metaData: {
            title: "पुजा किट सदस्यता – मासिक, तिमाही व वार्षिक योजना",
            description:
              "तुमच्या विधीसाठी आवश्यक सर्व सामग्रीसह तयार-उपयोग पूजा किट्स ऑर्डर करा. एक सोपी, भक्तीपूर्ण सेवा जी परंपरा आपल्या दारापर्यंत आणते.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "आपल्या दारापर्यंत मासिक, तिमाही किंवा वार्षिक आधारावर संपूर्ण पूजा किट्स मिळवा. प्रत्येक किटमध्ये दैनंदिन किंवा विशेष विधीसाठी आवश्यक सर्व साहित्य समाविष्ट आहे, ज्यामुळे वेळ व मेहनत वाचते. सोप्या आणि सुविधाजनक सदस्यता योजना आपल्या आध्यात्मिक प्रथेस अनुरूप आहेत. मायओमनमोवर विश्वास ठेवा, जेणेकरून पूजा सोपी आणि तणावमुक्त होईल आणि आपण मनःशांतीने भक्तीत लक्ष केंद्रित करू शकता.",
        },
      ]);
    } else if (Number(selectedLanguageID) === langID?.Hindi) {
      setData((prev) => [
        {
          headerName: "पंडित बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "मंदिर पूजाओं के साथ दिव्यता का अनुभव करें",
          route: "/services/book-puja",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "अपनी पूजा के लिए अनुभवी पंडित बुक करें",
          serviceName: "puja-booking",
          howItWorksMainHeading: "दिव्य आशीर्वाद की ओर सहज यात्रा",
          howItWorks: [
            {
              howItWorksTitle: "अपना समारोह चुनें",
              howItWorksDesc:
                "विवाह, गृह प्रवेश, नामकरण या कोई भी विशेष पूजा – जो आपको चाहिए उसे चुनें।",
            },
            {
              howItWorksTitle: "अपनी पूजा बुक करें",
              howItWorksDesc:
                "हमारे अनुभवी पंडित प्रत्येक विधि श्रद्धा, भक्ति और वेद शास्त्रों के अनुसार संपन्न करते हैं।",
            },
            {
              howItWorksTitle: "पवित्र वातावरण का अनुभव करें",
              howItWorksDesc:
                "पंडितजी सावधानीपूर्वक आपका समारोह संपन्न करते हैं। दिव्य ऊर्जा का अनुभव करें, श्रद्धा से जुड़ें और स्वास्थ्य, सुख एवं समृद्धि का आशीर्वाद प्राप्त करें।",
            },
          ],
          testimonials: [
            {
              Desc: "मैंने सत्यनारायण पूजा Myomnamo के माध्यम से बुक की थी और सभी व्यवस्थाएँ उत्कृष्ट रूप से की गईं। पंडित विद्वान, समय के पाबंद और भक्तिभाव से विधि करने वाले थे। अत्यंत संतोषजनक अनुभव।",
              name: "राजेश सिंह",
              location: "दिल्ली",
            },
            {
              Desc: "मेरा गृह प्रवेश समारोह बहुत सुंदर रहा। पंडित समय पर आए और सभी पूजन सामग्री साथ लाए। पूरी प्रक्रिया अत्यंत सुचारु और मंगलमय रही। धन्यवाद, Myomnamo।",
              name: "प्रिया माने",
              location: "नाशिक",
            },
            {
              Desc: "मुझे नवग्रह शांति पूजा चाहिए थी और Myomnamo की वजह से यह बहुत आसान हो गया! मंत्रोच्चार, विधि और व्यवस्था सब उत्कृष्ट रूप से संपन्न हुए। यह सच में दिव्य अनुभव था।",
              name: "अमित कपूर",
              location: "मुंबई",
            },
            {
              Desc: "नवरात्रि में मैंने अपने घर पर पूजा आयोजित की और Myomnamo ने सभी व्यवस्थाएँ कीं। पूरी प्रक्रिया सरल थी और पंडितों ने सभी विधियाँ शास्त्रसम्मत ढंग से संपन्न कीं।",
              name: "राजेश कुलकर्णी",
              location: "नाशिक",
            },
          ],
          FaqObj: [
            {
              question: "मैं किन-किन पूजाओं के लिए बुकिंग कर सकता हूँ?",
              answer:
                "आप गणपति पूजा, नवरात्रि आरती, लक्ष्मी पूजा और अन्य कई विधियाँ बुक कर सकते हैं।",
              color: "#ffa415",
            },
            {
              question: "क्या मैं नियमित पूजा के लिए बुकिंग कर सकता हूँ?",
              answer:
                "बिल्कुल! आप दैनिक, साप्ताहिक या कई दिनों तक चलने वाली पूजा के लिए बुकिंग कर सकते हैं।",
              color: "#fc5528",
            },
            {
              question: "क्या पंडित अनुभवी और योग्य हैं?",
              answer:
                "हाँ, हमारे सभी पंडित अनुभवी, प्रशिक्षित और उचित वेद परंपरा के अनुसार विधि संपन्न करते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या मैं मंदिर में या घर पर पूजा बुक कर सकता हूँ?",
              answer:
                "हाँ, आप घर पर, मंदिर में या अपनी इच्छित स्थान पर पूजा की बुकिंग कर सकते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या आप ऑनलाइन पूजा की सुविधा प्रदान करते हैं?",
              answer:
                "हाँ, हम ऑनलाइन पूजा भी कराते हैं जहाँ पंडित विधि आभासी माध्यम से संपन्न करते हैं।",
              color: "#8139e7",
            },
          ],
          metaTitle: "ऑनलाइन पूजा बुक करें - सभी विधियों के लिए अनुभवी पंडित",
          metaDescription:
            "विवाह, गृह प्रवेश या किसी भी पूजा के लिए पंडित बुक करें। पूजा की विधियाँ श्रद्धा, भक्ति और परंपरा के अनुसार संपन्न की जाएँगी। आज ही अपनी बुकिंग शुरू करें!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा बुक करें - सभी विधियों के लिए अनुभवी पंडित",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "विवाह, गृह प्रवेश या किसी भी पूजा के लिए पंडित बुक करें। पूजा की विधियाँ श्रद्धा, भक्ति और परंपरा के अनुसार संपन्न की जाएँगी। आज ही अपनी बुकिंग शुरू करें!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "मैं किन-किन पूजाओं के लिए बुकिंग कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आप गणपति पूजा, नवरात्रि आरती, लक्ष्मी पूजा और अन्य कई विधियाँ बुक कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं नियमित पूजा के लिए बुकिंग कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "बिल्कुल! आप दैनिक, साप्ताहिक या कई दिनों तक चलने वाली पूजा के लिए बुकिंग कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या पंडित अनुभवी और योग्य हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हमारे सभी पंडित अनुभवी, प्रशिक्षित और उचित वेद परंपरा के अनुसार विधि संपन्न करते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं मंदिर में या घर पर पूजा बुक कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, आप घर पर, मंदिर में या अपनी इच्छित स्थान पर पूजा की बुकिंग कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या आप ऑनलाइन पूजा की सुविधा प्रदान करते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हम ऑनलाइन पूजा भी कराते हैं जहाँ पंडित विधि आभासी माध्यम से संपन्न करते हैं।",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा बुक करें - सभी विधियों के लिए अनुभवी पंडित",
            description:
              "विवाह, गृह प्रवेश या किसी भी पूजा के लिए पंडित बुक करें। पूजा की विधियाँ श्रद्धा, भक्ति और परंपरा के अनुसार संपन्न की जाएँगी। आज ही अपनी बुकिंग शुरू करें!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "अनुभवी पंडितों के मार्गदर्शन में अपने विशेष क्षणों को पवित्र बनाएं। चाहे वह विवाह हो, गृह प्रवेश, नामकरण या कोई भी पूजा – पंडित प्रत्येक विधि श्रद्धा और भक्ति से संपन्न करते हैं। उनका परंपराओं का ज्ञान आपके घर में शांति और सकारात्मकता लाता है। छोटे घरेलू समारोहों से लेकर बड़े आयोजनों तक, हम आपके कार्यक्रम में मंगलमय वातावरण निर्मित करते हैं। पूजा की विधियों से श्रद्धा से जुड़ाव बढ़ता है और स्वास्थ्य, सुख तथा समृद्धि का आशीर्वाद प्राप्त होता है। अनुभवी पंडित के मार्गदर्शन में प्रत्येक समारोह को विशेष और यादगार बनाएं।",
        },
        {
          headerName: "दैनिक पंडित बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: DailyPooja,
          tagLine: "मंदिर पूजाओं के साथ दिव्यता का अनुभव करें",
          sectionTitle: "अपनी सुविधा अनुसार दैनिक पूजा के लिए पंडित बुक करें",
          serviceBannerImg: DailyPujaBookingBannerImg,
          serviceName: "daily-puja-booking",
          howItWorksMainHeading:
            "अपनी सुविधा अनुसार दैनिक पूजा के लिए पंडित बुक करें",
          howItWorks: [
            {
              howItWorksTitle: "अपनी विधि चुनें",
              howItWorksDesc:
                "गणपति पूजा, नवरात्रि आरती या साधारण सुबह की प्रार्थना – जो सेवा चाहिए उसे चुनें। हम आपको अनुभवी पंडित से जोड़ेंगे।",
            },
            {
              howItWorksTitle: "अपना समय निर्धारित करें",
              howItWorksDesc:
                "अपनी दिनचर्या के अनुसार तिथि और समय चुनें। पंडित सुबह और शाम उपलब्ध हैं, जिससे आप अपनी सुविधा अनुसार पूजा निर्धारित कर सकते हैं।",
            },
            {
              howItWorksTitle: "दिव्य आशीर्वाद का अनुभव करें",
              howItWorksDesc:
                "आपके पंडित सभी आवश्यक पूजन सामग्री के साथ आते हैं। अपने स्थान पर शांति, सकारात्मकता और दिव्य ऊर्जा का अनुभव करें।",
            },
          ],
          testimonials: [
            {
              Desc: "मैंने दैनिक गणेश पूजा के लिए बुकिंग की और इससे मेरे घर में बहुत सकारात्मकता आई है। पंडित भक्तिभाव से विधि करते हैं और सब कुछ व्यवस्थित रहता है। मैं बहुत आभारी हूँ।",
              name: "अंजली राजपूत",
              location: "मुंबई",
            },
            {
              Desc: "मेरे परिवार को दैनिक शिव अभिषेक चाहिए था और Myomnamo की वजह से यह बिल्कुल आसान हो गया। पंडित समय पर आते हैं, विद्वान हैं और उचित वेद परंपरा के अनुसार पूजा करते हैं। अत्यंत अनुशंसनीय।",
              name: "सुरेश काळे",
              location: "नाशिक",
            },
            {
              Desc: "मैंने मासिक लक्ष्मी पूजा सेवा ली और अनुभव बहुत अच्छा रहा। प्रार्थनाएँ मन से की जाती हैं, जिससे घर में शांति और समृद्धि आती है।",
              name: "मीरा सावंत",
              location: "बंगळूर",
            },
            {
              Desc: "आस्था रखने वाले लेकिन व्यस्त लोगों के लिए Myomnamo की यह बहुत अच्छी सुविधा है।",
              name: "चेतन पवार",
              location: "चंद्रपूर",
            },
            {
              Desc: "हर सुबह मुझे पूजा के बारे में अपडेट मिलता है। दिन की शुरुआत सकारात्मकता से होती है। Myomnamo का धन्यवाद।",
              name: "अर्जुन शिंदे",
              location: "जळगाव",
            },
          ],
          FaqObj: [
            {
              question: "दैनिक पूजा बुकिंग सेवा क्या है?",
              answer:
                "इसके माध्यम से आप घर या मंदिर में दैनिक पूजा के लिए पंडित बुक कर सकते हैं।",
              color: "#ffa415",
            },
            {
              question: "मैं अपनी विधि के लिए पंडित कैसे बुक करूँ?",
              answer:
                "आप आसानी से ऑनलाइन पंडित बुक कर सकते हैं – अपनी विधि चुनें, तिथि निर्धारित करें और बुकिंग की पुष्टि करें।",
              color: "#fc5528",
            },
            {
              question: "क्या मैं विशेष पंडित चुन सकता हूँ?",
              answer:
                "हाँ, उपलब्धता और आपकी पसंदीदा भाषा या परंपरा के अनुसार पंडित चुन सकते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या मैं रोज़ निश्चित समय पर पूजा निर्धारित कर सकता हूँ?",
              answer:
                "हाँ, आप अपनी सुविधा अनुसार रोज़ निश्चित समय पर पूजा आयोजित कर सकते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या मैं वर्चुअल दैनिक पूजा बुक कर सकता हूँ?",
              answer:
                "हाँ, हम ऑनलाइन पूजा की सुविधा देते हैं जहाँ पंडित विधि आभासी माध्यम से संपन्न करते हैं।",
              color: "#8139e7",
            },
          ],
          route: "/services/daily-booking",
          metaTitle:
            "दैनिक पूजा बुकिंग ऑनलाइन - सुबह और शाम की विधियों के लिए विश्वसनीय पंडित",
          metaDescription:
            "अपनी दैनिक पूजा के लिए अनुभवी पंडित बुक करें। अपनी विधि चुनें, समय निर्धारित करें और घर पर सहजता से दिव्य आशीर्वाद आमंत्रित करें। आज ही सुबह या शाम के लिए बुक करें।",
          cannonicalLink:
            "https://www.myomnamo.com/services/daily-puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "दैनिक पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/daily-puja-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "दैनिक पूजा बुकिंग ऑनलाइन - सुबह और शाम की विधियों के लिए विश्वसनीय पंडित",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            description:
              "अपनी दैनिक पूजा के लिए अनुभवी पंडित बुक करें। अपनी विधि चुनें, समय निर्धारित करें और घर पर सहजता से दिव्य आशीर्वाद आमंत्रित करें। आज ही सुबह या शाम के लिए बुक करें।",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "दैनिक पूजा बुकिंग सेवा क्या है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "इसके माध्यम से आप घर या मंदिर में दैनिक पूजा के लिए पंडित बुक कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "मैं अपनी विधि के लिए पंडित कैसे बुक करूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आप आसानी से ऑनलाइन पंडित बुक कर सकते हैं – अपनी विधि चुनें, तिथि निर्धारित करें और बुकिंग की पुष्टि करें।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं विशेष पंडित चुन सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, उपलब्धता और आपकी पसंदीदा भाषा या परंपरा के अनुसार पंडित चुन सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं रोज़ निश्चित समय पर पूजा निर्धारित कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, आप अपनी सुविधा अनुसार रोज़ निश्चित समय पर पूजा आयोजित कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं वर्चुअल दैनिक पूजा बुक कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हम ऑनलाइन पूजा की सुविधा देते हैं जहाँ पंडित विधि आभासी माध्यम से संपन्न करते हैं।",
                },
              },
            ],
          },
          metaData: {
            title:
              "दैनिक पूजा बुकिंग ऑनलाइन - सुबह और शाम की विधियों के लिए विश्वसनीय पंडित",
            description:
              "अपनी दैनिक पूजा के लिए अनुभवी पंडित बुक करें। अपनी विधि चुनें, समय निर्धारित करें और घर पर सहजता से दिव्य आशीर्वाद आमंत्रित करें। आज ही सुबह या शाम के लिए बुक करें।",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "घर या किसी कार्यक्रम में दैनिक पूजा के लिए पंडित चाहिए? अनुभवी पंडित प्रतिदिन सुबह और शाम उपलब्ध हैं और वे भक्तिभाव से आपके आध्यात्मिक अनुभव का मार्गदर्शन करते हैं। चाहे दस दिन का गणपति पूजन हो, नवरात्रि आरती हो या कई दिनों तक चलने वाला समारोह – हर चरण शास्त्रसम्मत रूप से संपन्न किया जाता है। मंत्रोच्चार से आरती तक सभी विधियाँ सही तरीके से की जाती हैं। अपने घर में प्रतिदिन शांति, सकारात्मकता और दिव्य आशीर्वाद लाएँ। अनुभवी पंडित के मार्गदर्शन में रोज़ दिव्य आशीर्वाद का अनुभव करें।",
        },
        {
          headerName: "पूजा बुकिंग सेवा",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "पूजाओं के माध्यम से दिव्यता को अपनाएं",
          route: "/puja-book",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "अपने आध्यात्मिक क्षणों के लिए पूजा बुक करें",
          serviceName: "pujas",
          howItWorksMainHeading: "दिव्य कृपा का सरल मार्ग",
          howItWorks: [
            {
              howItWorksTitle: "अपना समारोह चुनें",
              howItWorksDesc:
                "विवाह, गृह प्रवेश, नामकरण या कोई भी विशेष पूजा – जो पूजा आपको चाहिए उसे चुनें।",
            },
            {
              howItWorksTitle: "अपनी पूजा बुक करें",
              howItWorksDesc:
                "हमारे अनुभवी पंडित प्रत्येक विधि श्रद्धा, भक्ति और शास्त्रोक्त विधि से संपन्न करते हैं।",
            },
            {
              howItWorksTitle: "पवित्र वातावरण का अनुभव करें",
              howItWorksDesc:
                "पंडितजी आपका समारोह आदरपूर्वक संपन्न करते हैं। दिव्य ऊर्जा का अनुभव करें, श्रद्धा से जुड़ें और स्वास्थ्य, आनंद एवं समृद्धि का आशीर्वाद प्राप्त करें।",
            },
          ],
          testimonials: [
            {
              Desc: "मैंने सत्यनारायण पूजा Myomnamo के माध्यम से बुक की और सब कुछ बहुत अच्छी तरह से व्यवस्थित हुआ। पंडितजी विद्वान, समय के पाबंद और पूर्ण भक्तिभाव से पूजा संपन्न करने वाले थे। अत्यंत अनुशंसनीय।",
              name: "राजेश सिंह",
              location: "दिल्ली",
            },
            {
              Desc: "मेरा गृह प्रवेश पूजा बहुत सुंदर ढंग से संपन्न हुआ। पंडितजी समय पर आए और आवश्यक सामग्री साथ लाए। पूरी प्रक्रिया सुचारु और मंगलमय रही। धन्यवाद Myomnamo।",
              name: "प्रिया माने",
              location: "नाशिक",
            },
            {
              Desc: "मुझे नवग्रह शांति पूजा चाहिए थी और Myomnamo ने इसे बहुत आसान बना दिया! मंत्रोच्चार, विधि और तैयारी बिल्कुल सटीक रही। सचमुच दिव्य अनुभव।",
              name: "अमित कपूर",
              location: "मुंबई",
            },
            {
              Desc: "Myomnamo ने नवरात्रि के दौरान मेरे घर पर पूजा आयोजित करने में मदद की। पूरी प्रक्रिया सुचारु रही और पंडितजी ने सभी विधियाँ विधिपूर्वक संपन्न कीं।",
              name: "राजेश कुलकर्णी",
              location: "नाशिक",
            },
          ],
          FaqObj: [
            {
              question: "मैं किस प्रकार की पूजाओं की बुकिंग कर सकता हूँ?",
              answer:
                "आप गणपति पूजा, नवरात्रि आरती, लक्ष्मी पूजा और अन्य कई विधियों की बुकिंग कर सकते हैं।",
              color: "#ffa415",
            },
            {
              question: "क्या मैं नियमित होने वाली पूजाओं की बुकिंग कर सकता हूँ?",
              answer:
                "हाँ! आप अपनी आवश्यकता अनुसार दैनिक, साप्ताहिक या कई दिनों तक चलने वाली पूजाओं का समय निर्धारित कर सकते हैं।",
              color: "#fc5528",
            },
            {
              question: "क्या पंडितजी अनुभवी और योग्य हैं?",
              answer:
                "हाँ, हमारे सभी पंडितजी अनुभवी, प्रशिक्षित और उचित वैदिक विधि से अनुष्ठान संपन्न करते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या मैं घर या मंदिर के लिए पूजा बुक कर सकता हूँ?",
              answer:
                "हाँ, आप घर, मंदिर या किसी भी पसंदीदा स्थान पर पूजा बुक कर सकते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या आप ऑनलाइन पूजा सेवा प्रदान करते हैं?",
              answer:
                "हाँ, हम वर्चुअल पूजा सेवा प्रदान करते हैं जहाँ पंडितजी ऑनलाइन विधि संपन्न करते हैं।",
              color: "#8139e7",
            },
          ],
          metaTitle: "ऑनलाइन पूजा बुक करें - सभी समारोहों के लिए अनुभवी पंडित",
          metaDescription:
            "विवाह, गृह प्रवेश या कोई भी पूजा बुक करें। अनुभवी पंडित श्रद्धा, भक्ति और परंपरा के अनुसार विधि संपन्न करेंगे। अभी अपनी पूजा बुकिंग शुरू करें!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा बुक करें - सभी समारोहों के लिए अनुभवी पंडित",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "विवाह, गृह प्रवेश या कोई भी पूजा बुक करें। अनुभवी पंडित श्रद्धा, भक्ति और परंपरा के अनुसार विधि संपन्न करेंगे। अभी अपनी पूजा बुकिंग शुरू करें!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "मैं किस प्रकार की पूजाओं की बुकिंग कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आप गणपति पूजा, नवरात्रि आरती, लक्ष्मी पूजा और अन्य कई विधियों की बुकिंग कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं नियमित होने वाली पूजाओं की बुकिंग कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ! आप अपनी आवश्यकता अनुसार दैनिक, साप्ताहिक या कई दिनों तक चलने वाली पूजाओं का समय निर्धारित कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या पंडितजी अनुभवी और योग्य हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हमारे सभी पंडितजी अनुभवी, प्रशिक्षित और उचित वैदिक विधि से अनुष्ठान संपन्न करते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या मैं घर या मंदिर के लिए पूजा बुक कर सकता हूँ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, आप घर, मंदिर या किसी भी पसंदीदा स्थान पर पूजा बुक कर सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या आप ऑनलाइन पूजा सेवा प्रदान करते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हम वर्चुअल पूजा सेवा प्रदान करते हैं जहाँ पंडितजी ऑनलाइन विधि संपन्न करते हैं।",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा बुक करें - सभी समारोहों के लिए अनुभवी पंडित",
            description:
              "विवाह, गृह प्रवेश या कोई भी पूजा बुक करें। अनुभवी पंडित श्रद्धा, भक्ति और परंपरा के अनुसार विधि संपन्न करेंगे। अभी अपनी पूजा बुकिंग शुरू करें!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "अपने विशेष क्षणों को अनुभवी पंडितों के मार्गदर्शन में मंगलमय बनाएं। चाहे विवाह हो, गृह प्रवेश, नामकरण या कोई भी पूजा – पंडितजी प्रत्येक विधि भक्तिभाव और शास्त्रोक्त विधि से संपन्न करते हैं। उनके परंपरागत ज्ञान से आपके घर या समारोह में शांति और सकारात्मकता आती है। छोटे घरेलू पूजन से लेकर बड़े आयोजनों तक, हम आपके समारोह में श्रद्धा और मंगलमय वातावरण लाते हैं। विधियों के माध्यम से आपकी श्रद्धा और अधिक सशक्त होती है तथा स्वास्थ्य, आनंद और समृद्धि का आशीर्वाद प्राप्त होता है। अनुभवी पंडितों के साथ हर समारोह को विशेष और अविस्मरणीय बनाएं।",
        },
        {
          headerName: "राशिभविष्य पढ़ना",
          Imgabout1: About1,
          Imgabout2: Horoscope,
          tagLine: "मंदिर की पूजा के माध्यम से दिव्यता को अपनाएं",
          route: "/basic-details",
          serviceBannerImg: HoroscopeBannerImg,
          cannonicalLink: "https://www.myomnamo.com/services/horoscope",
          serviceName: "horoscope",
          sectionTitle: "अपने तारों के रहस्य जानें",
          howItWorksMainHeading: "हमारा राशिभविष्य पढ़ना कैसे काम करता है",
          howItWorks: [
            {
              howItWorksTitle: "अपनी राशि चुनें",
              howItWorksDesc:
                "अपने जीवन, भावनाओं और भविष्य की संभावनाओं के बारे में व्यक्तिगत भविष्यवाणी के लिए अपनी राशि चुनें।",
            },
            {
              howItWorksTitle: "तुरंत मार्गदर्शन प्राप्त करें",
              howItWorksDesc:
                "प्रेम, करियर और कल्याण पर विस्तृत मार्गदर्शन के साथ दैनिक, साप्ताहिक या वार्षिक राशिभविष्य देखें।",
            },
            {
              howItWorksTitle: "अपने मार्ग को मार्गदर्शन दें",
              howItWorksDesc:
                "अपने राशिभविष्य के सुझावों का उपयोग करके निर्णय लें, शुभ दिन खोजें और जीवन में खुशी और संतुलन लाएं।",
            },
          ],
          testimonials: [
            {
              Desc: "Myomnamo से मिला व्यक्तिगत राशिभविष्य रिपोर्ट मेरे करियर और व्यक्तिगत जीवन को समझने में बहुत मददगार साबित हुआ। अत्यंत उपयोगी।",
              name: "अमित डुंबरे",
              location: "पुणे",
            },
            {
              Desc: "मुझे पहले ज्योतिष में ज्यादा रुचि नहीं थी, लेकिन Myomnamo के साप्ताहिक मार्गदर्शन ने वास्तव में सही निर्णय लेने में मदद की।",
              name: "वैशाली ठाकुर",
              location: "नागपुर",
            },
            {
              Desc: "Myomnamo का राशिभविष्य पढ़ना विस्तृत और समझने में आसान था। यह ज्यादा तकनीकी नहीं था और व्यावहारिक सुझाव दिए।",
              name: "रोहित पंसरे",
              location: "नाशिक",
            },
            {
              Desc: "मैंने Myomnamo का दैनिक राशिभविष्य पढ़ना शुरू किया और हर सुबह मुझे स्पष्टता और फोकस मिलता है। यह बहुत सटीक और अर्थपूर्ण लगता है।",
              name: "प्राची केळकर",
              location: "मुंबई",
            },
          ],
          FaqObj: [
            {
              question: "मंदिर की पूजा सेवा क्या है?",
              answer:
                "हमारी सेवा आपको ऑनलाइन मंदिर पूजा बुक करने की सुविधा देती है, जिससे प्रक्रिया सरल और बाधारहित होती है।",
              color: "#ffa415",
            },
            {
              question: "मैं पूजा कैसे बुक करूं?",
              answer:
                "आप ऑनलाइन या मंदिर में पूजा बुक कर सकते हैं। पूजा प्रकार, तारीख और समय चुनें।",
              color: "#fc5528",
            },
            {
              question: "किस प्रकार की पूजाएँ उपलब्ध हैं?",
              answer:
                "हम जन्मदिन, त्यौहार, व्यक्तिगत प्रार्थना और विशेष समारोहों के लिए पूजा प्रदान करते हैं।",
              color: "#8139e7",
            },
            {
              question: "विशेष या निजी पूजा उपलब्ध हैं क्या?",
              answer:
                "हाँ, कुछ मंदिरों में व्यक्तिगत विधियों के साथ विशेष निजी पूजा उपलब्ध हैं।",
              color: "#8139e7",
            },
          ],
          metaTitle: "राशिभविष्य पढ़ना - अपना भविष्य जानें",
          metaDescription:
            "प्रेम, करियर और जीवन के निर्णयों के लिए मार्गदर्शन प्राप्त करें। अपनी राशि के अनुसार दैनिक, साप्ताहिक या वार्षिक राशिभविष्य जानें। आज ही परामर्श बुक करें।",
          canonicalLink: "https://www.myomnamo.com/services/horoscope",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "राशिभविष्य",
                item: "https://www.myomnamo.com/services/horoscope",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "राशिभविष्य पढ़ना - अपना भविष्य जानें",
            url: "https://www.myomnamo.com/services/horoscope",
            description:
              "प्रेम, करियर और जीवन के निर्णयों के लिए मार्गदर्शन प्राप्त करें। अपनी राशि के अनुसार दैनिक, साप्ताहिक या वार्षिक राशिभविष्य जानें। आज ही परामर्श बुक करें।",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          metaData: {
            title: "राशिभविष्य पढ़ना - अपना भविष्य जानें",
            description:
              "प्रेम, करियर और जीवन के निर्णयों के लिए मार्गदर्शन प्राप्त करें। अपनी राशि के अनुसार दैनिक, साप्ताहिक या वार्षिक राशिभविष्य जानें। आज ही परामर्श बुक करें।",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/horoscope",
            siteName: "Myomnamo",
            locale: "mr_IN",
          },
          mainContent:
            "सरल राशिभविष्य पढ़ाई के माध्यम से अपना भविष्य जानें। अपने दिन, सप्ताह या वर्ष के बारे में तुरंत जानकारी प्राप्त करें। प्रेम, कार्य, स्वास्थ्य और अन्य क्षेत्रों पर अंतर्दृष्टि प्राप्त करें। बड़ा निर्णय लेना हो या केवल जिज्ञासा हो, राशिभविष्य आपको सही मार्गदर्शन देगा। शुभ दिन, उपयोगी सुझाव और जीवन में अधिक आनंद लाने के उपाय खोजें। अपने उज्ज्वल भविष्य की ओर तारों की मार्गदर्शिता प्राप्त करें।",
        },
        {
          headerName: "ऑनलाइन पूजा सामग्री स्टोर",
          Imgabout1: About1,
          Imgabout2: Ecart,
          tagLine: "मंदिर पूजा के साथ दिव्य अनुभव प्राप्त करें",
          serviceBannerImg: EstoreBannerImg,
          route: "/my-store",
          serviceName: "e-store",
          howItWorksMainHeading: "ई-स्टोर के साथ पूजा खरीदना आसान",
          howItWorks: [
            {
              howItWorksTitle: "ब्राउज़ करें और चुनें",
              howItWorksDesc:
                "हमारी विस्तृत पूजा सामग्री श्रेणी में खोजें। अपनी आध्यात्मिक आवश्यकता के अनुसार पूजा सामग्री या पूरा पूजा किट चुनें।",
            },
            {
              howItWorksTitle: "ऑर्डर करें और भुगतान करें",
              howItWorksDesc:
                "अपनी चुनी हुई वस्तु को कार्ट में डालें, सुरक्षित रूप से चेकआउट करें और सुविधाजनक भुगतान विकल्प चुनें।",
            },
            {
              howItWorksTitle: "प्राप्त करें और पूजा करें",
              howItWorksDesc:
                "अपना ऑर्डर दरवाजे तक प्राप्त करें। अपने विधि को शांति से पूरा करें, सभी वस्तुएँ तैयार और पवित्र होंगी।",
            },
          ],
          testimonials: [
            {
              Desc: "मैंने लक्ष्मी मूर्ति और रुद्राक्ष माला ऑर्डर की, और गुणवत्ता ने मुझे बहुत खुश किया। वस्तुएँ ठीक से पैक की गई थीं और समय पर पहुंचीं।",
              name: "पूजा मोरे",
              location: "पुणे",
            },
            {
              Desc: "मैंने पूरा पूजा किट खरीदा, जिससे मेरे विधि सरल हो गए। सभी वस्तुएँ प्रमाणिक और पवित्र थीं। अत्यधिक अनुशंसित।",
              name: "विकास राठी",
              location: "बेंगलुरु",
            },
            {
              Desc: "मैंने ई-स्टोर से अगरबत्ती और शंख खरीदे। डिलीवरी तेज़ थी और पैकेजिंग उत्कृष्ट थी। पुनः खरीदूँगा।",
              name: "मीनल शिंदे",
              location: "जयपुर",
            },
            {
              Desc: "Myomnamo के ई-स्टोर से खरीदना आसान और सुविधाजनक था। मुझे सभी पूजा सामग्री एक ही जगह पर मिल गई।",
              name: "सागर शिंदे",
              location: "मुंबई",
            },
          ],
          FaqObj: [
            {
              question: "आप कौन-कौन सी उत्पादें प्रदान करते हैं?",
              answer:
                "हम पूजा सामग्री, पूरा किट, मूर्ति, अगरबत्ती, फूल और दैनिक विधि या विशेष समारोहों के लिए आवश्यक सभी वस्तुएँ उपलब्ध कराते हैं।",
              color: "#ffa415",
            },
            {
              question: "क्या आप तेज़ डिलीवरी प्रदान करते हैं?",
              answer:
                "हाँ! हम सुनिश्चित करते हैं कि आपको समय पर वस्तुएँ मिलें ताकि आपकी पूजा या उत्सव समय पर पूरी हो।",
              color: "#fc5528",
            },
            {
              question: "क्या उत्पाद प्रमाणिक और पवित्र हैं?",
              answer:
                "हाँ, हमारे उत्पाद विश्वसनीय विक्रेताओं से प्राप्त होते हैं और कई वस्तुएँ आध्यात्मिक दृष्टि से पवित्र होती हैं।",
              color: "#8139e7",
            },
          ],
          sectionTitle: "आपका एकमात्र ऑनलाइन ई-स्टोर",
          metaTitle:
            "ऑनलाइन पूजा सामग्री स्टोर - Myomnamo पर पूजा सामग्री खरीदें",
          metaDescription:
            "Myomnamo पर प्रमाणिक पूजा सामग्री और वस्तुएँ ऑनलाइन खरीदें। सभी प्रकार की विधि और समारोहों के लिए वस्तुएँ प्राप्त करें। तेज़ डिलीवरी और भरोसेमंद गुणवत्ता।",
          cannonicalLink: "https://www.myomnamo.com/services/e-store",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा सामग्री स्टोर",
                item: "https://www.myomnamo.com/services/e-store",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "ऑनलाइन पूजा सामग्री स्टोर - Myomnamo पर पूजा सामग्री खरीदें",
            url: "https://www.myomnamo.com/services/e-store",
            description:
              "Myomnamo पर प्रमाणिक पूजा सामग्री और वस्तुएँ ऑनलाइन खरीदें। सभी प्रकार की विधि और समारोहों के लिए वस्तुएँ प्राप्त करें। तेज़ डिलीवरी और भरोसेमंद गुणवत्ता।",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "आप कौन-कौन सी उत्पादें प्रदान करते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हम पूजा सामग्री, पूरा किट, मूर्ति, अगरबत्ती, फूल और दैनिक विधि या विशेष समारोहों के लिए आवश्यक सभी वस्तुएँ उपलब्ध कराते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या आप तेज़ डिलीवरी प्रदान करते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ! हम सुनिश्चित करते हैं कि आपको समय पर वस्तुएँ मिलें ताकि आपकी पूजा या उत्सव समय पर पूरी हो।",
                },
              },
              {
                "@type": "Question",
                name: "क्या उत्पाद प्रमाणिक और पवित्र हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, हमारे उत्पाद विश्वसनीय विक्रेताओं से प्राप्त होते हैं और कई वस्तुएँ आध्यात्मिक दृष्टि से पवित्र होती हैं।",
                },
              },
            ],
          },
          metaData: {
            title: "ऑनलाइन पूजा सामग्री स्टोर - Myomnamo पर पूजा सामग्री खरीदें",
            description:
              "Myomnamo पर प्रमाणिक पूजा सामग्री और वस्तुएँ ऑनलाइन खरीदें। सभी प्रकार की विधि और समारोहों के लिए वस्तुएँ प्राप्त करें। तेज़ डिलीवरी और भरोसेमंद गुणवत्ता।",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/e-store",
            siteName: "Myomnamo",
            locale: "hi_IN",
          },
          mainContent:
            "घर बैठे अपनी पूजा आवश्यकताओं को पूरा करें। पूजा सामग्री, पूरा पूजा किट, मूर्ति, अगरबत्ती और अन्य वस्तुएँ प्राप्त करें। दैनिक पूजा या विशेष उत्सव के लिए आवश्यक सभी वस्तुएँ एक साथ पाएं। विभिन्न दुकानों पर जाने की आवश्यकता नहीं, बस ब्राउज़ करें और वस्तुएँ आपके दरवाजे पर पहुँचें। हर समारोह को अर्थपूर्ण बनाएं सही वस्तुओं, पवित्र फूल और धार्मिक सामग्री के साथ। अपनी श्रद्धा को सशक्त करें हर आध्यात्मिक अवसर पर सही सामग्री के साथ।",
        },
        {
          headerName: "भक्ति पूजा किट",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "भक्ति किट जानकारी",
          route: "/services/puja-kit",
          serviceBannerImg: LandingPujaKit,
          sectionTitle: "पूर्ण पूजा सामग्री किट",
          serviceName: "puja-kit-services",
          howItWorksMainHeading: "Myomnamo के साथ पूजा किट बुक करें",
          howItWorks: [
            {
              howItWorksTitle: "अपनी सदस्यता चुनें",
              howItWorksDesc:
                "मासिक, तिमाही या वार्षिक योजना चुनें और कुछ आसान चरणों में अपनी पूजा किट ऑनलाइन बुक करें।",
            },
            {
              howItWorksTitle: "व्यक्तिगत बनाएं और पुष्टि करें",
              howItWorksDesc:
                "अपनी वितरण जानकारी और प्राथमिकताएँ साझा करें। पुष्टि प्राप्त करें और चुनी गई योजना में प्रीमियम लकड़ी के बॉक्स के साथ किट प्राप्त करें।",
            },
            {
              howItWorksTitle: "प्राप्त करें और नवीनीकरण करें",
              howItWorksDesc:
                "ताजा, उच्च गुणवत्ता वाली सामग्री अपने दरवाजे तक प्राप्त करें। तिमाही और दीर्घकालिक योजनाएँ मासिक सामग्री आपूर्ति के साथ आती हैं, जिससे आपको सुविधा मिलती है।",
            },
          ],
          testimonials: [
            {
              Desc: "इस पूजा किट में मुझे जो चाहिए था वह सब कुछ था। किट व्यवस्थित था और पूजा आसान हो गई। Myomnamo ने बेहतरीन योजना बनाई।",
              name: "लक्ष्मी करले",
              location: "जलगांव",
            },
            {
              Desc: "उत्पाद की गुणवत्ता उत्कृष्ट थी। बाजार में भागे बिना सभी विधियाँ पूरी कर पाई।",
              name: "श्रीकांत मुले",
              location: "अहिल्यानगर",
            },
            {
              Desc: "किट आखिरी समय में ऑर्डर किया, लेकिन समय पर पहुँचा। Myomnamo की सेवा बहुत उपयोगी थी।",
              name: "मानसी गोखले",
              location: "मुंबई",
            },
            {
              Desc: "जो कोई घर बैठे सही पूजा करना चाहता है उसके लिए संपूर्ण किट। धन्यवाद Myomnamo।",
              name: "राहुल पावसकर",
              location: "रत्नगिरी",
            },
          ],
          FaqObj: [
            {
              question: "पूजा किट में क्या सामग्री है?",
              answer:
                "हर किट में दैनिक या विशेष विधियों के लिए आवश्यक सभी सामग्री शामिल होती है। सभी वस्तुएँ सुविधाजनक रूप से पैक की जाती हैं ताकि आपकी पूजा आसानी से संपन्न हो।",
              color: "#ffa415",
            },
            {
              question: "पूजा किट कितनी बार प्राप्त हो सकती है?",
              answer:
                "आप मासिक, तिमाही या वार्षिक वितरण चुन सकते हैं। अपनी पूजा आदतों के अनुसार विकल्प चुनें।",
              color: "#fc5528",
            },
            {
              question: "क्या मुझे स्वयं पूजा सामग्री व्यवस्थित करनी होगी?",
              answer:
                "नहीं, हम सभी पवित्र सामग्री प्रदान करते हैं। केवल डिवाइस (फोन/लैपटॉप) के माध्यम से लाइव सत्र में शामिल हों और आध्यात्मिक सहभागिता करें।",
              color: "#8139e7",
            },
            {
              question: "क्या किट किफायती हैं?",
              answer:
                "हाँ, किट बजट-फ्रेंडली हैं। अधिक खर्च किए बिना आप अपनी आध्यात्मिक प्रथा जारी रख सकते हैं।",
              color: "#8139e7",
            },
            {
              question: "क्या सदस्यता के बाद बदलाव किया जा सकता है?",
              answer:
                "हाँ, आप अपनी योजना कभी भी बदल या अपडेट कर सकते हैं। अपनी आवश्यकता अनुसार सदस्यता बदलना आसान है।",
              color: "#8139e7",
            },
          ],
          metaTitle: "पूजा किट सदस्यता – मासिक, तिमाही और वार्षिक योजना",
          metaDescription:
            "अपनी विधि के लिए आवश्यक सभी सामग्री के साथ तैयार-उपयोग पूजा किट ऑर्डर करें। एक सरल, भक्ति-पूर्ण सेवा जो परंपरा को आपके दरवाजे तक लाती है।",
          cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "मुख्य पृष्ठ",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "पूजा बुकिंग",
                item: "https://www.myomnamo.com/services/puja-kit-services",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "पूजा किट सदस्यता – मासिक, तिमाही और वार्षिक योजना",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            description:
              "अपनी विधि के लिए आवश्यक सभी सामग्री के साथ तैयार-उपयोग पूजा किट ऑर्डर करें। एक सरल, भक्ति-पूर्ण सेवा जो परंपरा को आपके दरवाजे तक लाती है।",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "पूजा किट में क्या सामग्री है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हर किट में दैनिक या विशेष विधियों के लिए आवश्यक सभी सामग्री शामिल होती है। सभी वस्तुएँ सुविधाजनक रूप से पैक की जाती हैं ताकि आपकी पूजा आसानी से संपन्न हो।",
                },
              },
              {
                "@type": "Question",
                name: "पूजा किट कितनी बार प्राप्त हो सकती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आप मासिक, तिमाही या वार्षिक वितरण चुन सकते हैं। अपनी पूजा आदतों के अनुसार विकल्प चुनें।",
                },
              },
              {
                "@type": "Question",
                name: "क्या किट किफायती हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, किट बजट-फ्रेंडली हैं। अधिक खर्च किए बिना आप अपनी आध्यात्मिक प्रथा जारी रख सकते हैं।",
                },
              },
              {
                "@type": "Question",
                name: "क्या सदस्यता के बाद बदलाव किया जा सकता है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हाँ, आप अपनी योजना कभी भी बदल या अपडेट कर सकते हैं। अपनी आवश्यकता अनुसार सदस्यता बदलना आसान है।",
                },
              },
            ],
          },
          metaData: {
            title: "पूजा किट सदस्यता – मासिक, तिमाही और वार्षिक योजना",
            description:
              "अपनी विधि के लिए आवश्यक सभी सामग्री के साथ तैयार-उपयोग पूजा किट ऑर्डर करें। एक सरल, भक्ति-पूर्ण सेवा जो परंपरा को आपके दरवाजे तक लाती है।",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            siteName: "Myomnamo",
            locale: "hi_IN",
          },
          mainContent:
            "मासिक, तिमाही या वार्षिक आधार पर अपने दरवाजे तक पूर्ण पूजा किट प्राप्त करें। प्रत्येक किट में दैनिक या विशेष विधियों के लिए सभी आवश्यक सामग्री शामिल है, जिससे समय और मेहनत की बचत होती है। सरल और सुविधाजनक सदस्यता योजनाएँ आपकी आध्यात्मिक प्रथा के अनुसार हैं। Myomnamo पर भरोसा करें, ताकि पूजा सरल और तनाव-मुक्त हो और आप मानसिक शांति के साथ भक्ति में ध्यान केंद्रित कर सकें।",
        },

      ]);
    }

    else {
      setData([
        {
          headerName: "Pandit Booking Service",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "Embrace Divinity with Temple Pujas",
          route: "/services/book-puja",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "Book an Experienced Pandit for Your Puja",
          serviceName: "puja-booking",
          howItWorksMainHeading: "Effortless Path to Divine Blessings",
          howItWorks: [
            {
              howItWorksTitle: "Select Your Ceremony",
              howItWorksDesc:
                "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
            },
            {
              howItWorksTitle: "Book Your Puja",
              howItWorksDesc:
                "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
            },
            {
              howItWorksTitle: "Embrace Sacred Vibes",
              howItWorksDesc:
                "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
            },
          ],
          testimonials: [
            {
              Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
              name: "Rajesh Singh",
              location: "Delhi",
            },
            {
              Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
              name: "Priya Mane",
              location: "Nashik",
            },
            {
              Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
              name: "Amit Kapoor",
              location: "Mumbai",
            },
            {
              Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
              name: "Rajesh Kulkarni",
              location: "Nashik",
            },
          ],
          FaqObj: [
            {
              question: "What types of puja’s can I book?",
              answer:
                "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
              color: "#ffa415",
            },
            {
              question: "Can I book recurring pujas?",
              answer:
                "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
              color: "#fc5528",
            },
            {
              question: "Are the pandits experienced and qualified?",
              answer:
                "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
              color: "#8139e7",
            },
            {
              question: "Can I book a puja for a temple or home location?",
              answer:
                "Yes, you can book a puja for your home, temple, or any preferred location.",
              color: "#8139e7",
            },
            {
              question: "Do you offer online puja services?",
              answer:
                "Yes, we offer virtual pujas where pandits perform rituals online.",
              color: "#8139e7",
            },
            // {
            //   question: "Why is it important How Volunteer?",
            //   answer:
            //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
            //   color: "#399be7",
            // },
          ],
          metaTitle:
            "Book Puja Online - Experienced Pandits for All Ceremonies",
          metaDescription:
            "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Puja Booking",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Book Puja Online - Experienced Pandits for All Ceremonies",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What types of puja’s can I book?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book recurring pujas?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
                },
              },
              {
                "@type": "Question",
                name: "Are the pandits experienced and qualified?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book a puja for a temple or home location?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can book a puja for your home, temple, or any preferred location.",
                },
              },
              {
                "@type": "Question",
                name: "Do you offer online puja services?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we offer virtual pujas where pandits perform rituals online.",
                },
              },
            ],
          },
          metaData: {
            title: "Book Puja Online - Experienced Pandits for All Ceremonies",
            description:
              "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
        },
        {
          headerName: " Puja Booking Service",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "Embrace Divinity with  Pujas",
          route: "/puja-book",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "Book an Puja for Your Spiritual",
          serviceName: "pujas",
          howItWorksMainHeading: "Effortless Path to Divine Blessings",
          howItWorks: [
            {
              howItWorksTitle: "Select Your Ceremony",
              howItWorksDesc:
                "Choose the ritual you want to perform- a wedding, housewarming, naming ceremony, or any special puja. ",
            },
            {
              howItWorksTitle: "Book Your Puja",
              howItWorksDesc:
                "Our expert pandits ensure each ritual is conducted with care, devotion, and attention to sacred details. ",
            },
            {
              howItWorksTitle: "Embrace Sacred Vibes",
              howItWorksDesc:
                "Pandit leads your ceremony with care. Feel the divine energy, connect with your faith, and receive health, happiness, and prosperity blessings. ",
            },
          ],
          testimonials: [
            {
              Desc: "I booked a Satyanarayan Puja through Myomnamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
              name: "Rajesh Singh",
              location: "Delhi",
            },
            {
              Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, Myomnamo.",
              name: "Priya Mane",
              location: "Nashik",
            },
            {
              Desc: "I needed a Navagraha Shanti puja, and Myomnamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
              name: "Amit Kapoor",
              location: "Mumbai",
            },
            {
              Desc: "Myomnamo  helped me organize a puja at my house during Navratri. The whole process was smooth, and the pandit performed all the rituals properly.",
              name: "Rajesh Kulkarni",
              location: "Nashik",
            },
          ],
          FaqObj: [
            {
              question: "What types of puja’s can I book?",
              answer:
                "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
              color: "#ffa415",
            },
            {
              question: "Can I book recurring pujas?",
              answer:
                "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
              color: "#fc5528",
            },
            {
              question: "Are the pandits experienced and qualified?",
              answer:
                "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
              color: "#8139e7",
            },
            {
              question: "Can I book a puja for a temple or home location?",
              answer:
                "Yes, you can book a puja for your home, temple, or any preferred location.",
              color: "#8139e7",
            },
            {
              question: "Do you offer online puja services?",
              answer:
                "Yes, we offer virtual pujas where pandits perform rituals online.",
              color: "#8139e7",
            },
            // {
            //   question: "Why is it important How Volunteer?",
            //   answer:
            //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
            //   color: "#399be7",
            // },
          ],
          metaTitle:
            "Book Puja Online - Experienced Pandits for All Ceremonies",
          metaDescription:
            "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
          cannonicalLink: "https://www.myomnamo.com/services/puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Puja Booking",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Book Puja Online - Experienced Pandits for All Ceremonies",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What types of puja’s can I book?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book recurring pujas?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
                },
              },
              {
                "@type": "Question",
                name: "Are the pandits experienced and qualified?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book a puja for a temple or home location?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can book a puja for your home, temple, or any preferred location.",
                },
              },
              {
                "@type": "Question",
                name: "Do you offer online puja services?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we offer virtual pujas where pandits perform rituals online.",
                },
              },
            ],
          },
          metaData: {
            title: "Book Puja Online - Experienced Pandits for All Ceremonies",
            description:
              "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Make your special moments sacred with the guidance of an experienced pandit. Whether it’s a wedding, housewarming, naming ceremony, or any puja, a pandit ensures each ritual is done with care and devotion. Their knowledge of traditions brings peace and positivity to your home or event. From small home ceremonies to grand events, we bring positivity and tradition to your gathering. Performing rituals, helps you connect with your faith and look for blessings for health, happiness, and prosperity. Make every ceremony special and memorable with an experienced pandit who guides each step with care and kindness.",
        },
        {
          headerName: "Daily Pandit Booking Service",
          Imgabout1: About1,
          Imgabout2: DailyPooja,
          tagLine: "Embrace Divinity with Temple Pujas",
          sectionTitle: "Book a Pandit for Daily Puja at Your Convenience",
          serviceBannerImg: DailyPujaBookingBannerImg,
          serviceName: "daily-puja-booking",
          howItWorksMainHeading:
            "Book a Pandit for Daily Puja at Your Convenience",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Ritual",
              howItWorksDesc:
                "Whether it's Ganpati Puja, Navratri Aarti, or a simple morning prayer, select the service you need. We’ll connect you with an experienced pandit. ",
            },
            {
              howItWorksTitle: "Schedule Your Time",
              howItWorksDesc:
                "Pick a date and time that fits your routine. Pandits are available every morning and evening, so you can schedule rituals at your convenience. ",
            },
            {
              howItWorksTitle: "Experience Divine Blessings",
              howItWorksDesc:
                "Your dedicated pandit arrives with all the necessary items for the Puja. Feel peace, positivity, and divine energy fill your space.",
            },
          ],
          testimonials: [
            {
              Desc: " I booked a daily Ganesh Puja, and it has brought so much positivity to my home. The pandit performs the rituals with devotion, and everything is well-organized. Truly grateful.",
              name: "Anjali Rajput",
              location: "Mumbai",
            },
            {
              Desc: " My family wanted a daily Shiv Abhishek, and My OmNamo made it effortless. The pandit is punctual, knowledgeable, and follows proper Vedic traditions. Highly recommended.",
              name: "Suresh Kale",
              location: "Nashik",
            },
            {
              Desc: "I opted for a monthly Lakshmi Puja service, and the experience has been wonderful. The prayers are performed with sincerity, bringing peace and prosperity to our home.",
              name: "Meera Savant",
              location: "Bangalore",
            },
            {
              Desc: "A very good option by Myomnamo for working people who want to stay connected to their faith.",
              name: "Chetan Pawar",
              location: "Chandrapur",
            },
            {
              Desc: "Every morning, I get an update about the puja. It gives a positive start to my day. Grateful to Myomnamo.",
              name: "Arjun Shinde",
              location: "Jalgaon",
            },
          ],
          FaqObj: [
            {
              question: "What is a daily puja booking service?",
              answer:
                "It allows you to book a pandit for performing daily pujas at your home or temple.",
              color: "#ffa415",
            },
            {
              question: "How do I book a pandit for my ritual?",
              answer:
                "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
              color: "#fc5528",
            },
            {
              question: "Can I choose a specific pandit?",
              answer:
                "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
              color: "#8139e7",
            },
            {
              question: "Can I schedule pujas at a fixed time daily?",
              answer:
                "Yes, you can set a fixed time for your daily puja at your convenience.",
              color: "#8139e7",
            },
            {
              question: "Can I book a virtual daily puja?",
              answer:
                "Yes, we offer online pujas where pandits perform rituals.",
              color: "#8139e7",
            },
            // {
            //   question: "Why is it important How Volunteer?",
            //   answer:
            //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
            //   color: "#399be7",
            // },
          ],
          route: "/services/daily-booking",
          metaTitle:
            "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
          metaDescription:
            "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
          cannonicalLink:
            "https://www.myomnamo.com/services/daily-puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Daily Puja Booking",
                item: "https://www.myomnamo.com/services/daily-puja-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            description:
              "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is a daily puja booking service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "It allows you to book a pandit for performing daily pujas at your home or temple.",
                },
              },
              {
                "@type": "Question",
                name: "How do I book a pandit for my ritual?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can easily book a pandit online by selecting your ceremony, choosing a date, and confirming your booking.",
                },
              },
              {
                "@type": "Question",
                name: "Can I choose a specific pandit?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can choose a pandit based on availability and your preferred language or tradition.",
                },
              },
              {
                "@type": "Question",
                name: "Can I schedule pujas at a fixed time daily?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can set a fixed time for your daily puja at your convenience.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book a virtual daily puja?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we offer online pujas where pandits perform rituals.",
                },
              },
            ],
          },
          metaData: {
            title:
              "Daily Puja Booking Online - Trusted Pandits Morning & Evening Rituals",
            description:
              "Book an experienced pandit for your daily puja. Choose your ritual, pick a time, and welcome divine blessings to your home easily. Book now for morning or evening.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/daily-puja-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Looking for a pandit to perform daily pujas at home or at your event? Experienced pandits are available every morning and evening to guide you through your spiritual experience with care and devotion. Whether it's a 10-day Ganpati puja, a Navratri aarti, or any multi-day ceremony, we handle each step with accuracy and respect for tradition. From chanting mantras to performing aartis, we ensure your rituals are done properly. Bring peace, positivity, and divine blessings to your space every day. Experience divine blessings every day with a trusted pandit guiding your rituals.",
        },
        {
          headerName: "Online Puja Samagri Store",
          Imgabout1: About1,
          Imgabout2: Ecart,
          tagLine: "Embrace Divinity with Temple Pujas",
          serviceBannerImg: EstoreBannerImg,
          route: "/my-store",
          serviceName: "e-store",
          howItWorksMainHeading: "Puja Shopping Made Simple With E-store",
          howItWorks: [
            {
              howItWorksTitle: "Browse & Select",
              howItWorksDesc:
                "Explore our wide range of puja samagri. Choose puja samgari or complete puja kits customised to your spiritual needs. ",
            },
            {
              howItWorksTitle: "Order & Pay",
              howItWorksDesc:
                "Add products to your cart, securely check out, and choose convenient payment options for a smooth shopping experience. ",
            },
            {
              howItWorksTitle: "Receive & Worship",
              howItWorksDesc:
                "Get your order delivered to your door. Perform your rituals peacefully with everything you need ready and sacred.",
            },
          ],
          testimonials: [
            {
              Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
              name: "Puja More",
              location: "Pune",
            },
            {
              Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
              name: "Vikas Rathi",
              location: "Bangalore",
            },
            {
              Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
              name: "Meenal Shinde",
              location: "Jaipur",
            },
            {
              Desc: "Shopping from Myomnamo’s E-Store was easy and convenient. I got all my puja items in one place, without needing to visit multiple shops.",
              name: "Sagar Shinde",
              location: "Mumbai",
            },
          ],
          FaqObj: [
            {
              question: "What products do you offer?",
              answer:
                "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
              color: "#ffa415",
            },
            {
              question: "Do you offer fast delivery?",
              answer:
                "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
              color: "#fc5528",
            },
            {
              question: "Are the products authentic and blessed?",
              answer:
                "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
              color: "#8139e7",
            },
          ],
          sectionTitle: "Your One-Stop Online E-Store",
          metaTitle: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
          metaDescription:
            "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
          cannonicalLink: "https://www.myomnamo.com/services/e-store",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Puja Samagri Store",
                item: "https://www.myomnamo.com/services/e-store",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
            url: "https://www.myomnamo.com/services/e-store",
            description:
              "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What products do you offer?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We provide puja samagri, complete kits, idols, incense, flowers, and everything needed for daily rituals or special ceremonies.",
                },
              },
              {
                "@type": "Question",
                name: "Do you offer fast delivery?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes! We ensure quick and reliable delivery so you get your items on time for your puja or festival.",
                },
              },
              {
                "@type": "Question",
                name: "Are the products authentic and blessed?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, our products are sourced from trusted vendors and many items are spiritually blessed.",
                },
              },
            ],
          },
          metaData: {
            title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
            description:
              "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/e-store",
            siteName: "Myomnamo",
            locale: "en_IN",
          },

          mainContent:
            "Shop for all your puja needs from home. Get puja samagri, complete puja kits, idols, incense, and more. Whether it's for daily pujas or special festivals, have everything ready for your rituals. No need to visit multiple shops, just browse and get items delivered to your door.  Make every ceremony meaningful with the right products, from sacred flowers to holy offerings. Celebrate traditions easily, knowing you have everything needed for a peaceful and complete puja experience. Keep your devotion strong with the right products for every spiritual occasion.",
        },
        {
          headerName: "Online Darshan Booking",
          Imgabout1: About1,
          Imgabout2: templeBooking,
          tagLine: "Embrace Divinity with Temple Pujas",
          sectionTitle: "Easy Temple Darshan Booking Online",
          serviceBannerImg: DarshanBookingBannerImg,
          serviceName: "darshan-booking",
          cannonicalLink: "https://www.myomnamo.com/services/darshan-booking",
          route: "/darshan-booking",
          howItWorksMainHeading: "Simple & Time-Saving Darshan Booking",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Temple",
              howItWorksDesc:
                "Select your temple and preferred date for darshan. Plan your visit effortlessly, even during peak times. ",
            },
            {
              howItWorksTitle: "Book Your Slot",
              howItWorksDesc:
                "Reserve your darshan slot online in minutes. Avoid long queues and secure a peaceful, hassle-free temple experience.",
            },
            {
              howItWorksTitle: "Get Confirmation",
              howItWorksDesc:
                "Receive instant booking confirmation via email or SMS. Show your details at the temple and enjoy your visit stress-free.",
            },
          ],
          testimonials: [
            {
              Desc: " Booking temple darshan online saved me so much time! No long queues and the process was smooth. Truly a divine experience.",
              name: "Rohit Pawar",
              location: "Yeola",
            },
            {
              Desc: "I booked a VIP darshan for my family, and everything went perfectly. The confirmation was instant, and we had a peaceful visit.",
              name: "Neha Tile",
              location: "Nagpur",
            },
            {
              Desc: "This service made temple visits stress-free. I booked my darshan in advance and had a smooth entry without any hassle. Highly recommended.",
              name: "Amit Patil",
              location: "Jaipur",
            },
            {
              Desc: "My elderly parents were able to do darshan without travelling. This meant a lot to us. Thank you Myomnamo.",
              name: "Bhavana Salunkhe",
              location: "Nanded",
            },

            {
              Desc: "The process was simple and the darshan was well organised by Myomnamo.",
              name: "Gaurav Jadhav",
              location: "Ratnagiri",
            },
          ],
          FaqObj: [
            {
              question: "What is the Darshan Booking service?",
              answer:
                "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
              color: "#ffa415",
            },
            {
              question: "Can I book darshan for multiple people?",
              answer:
                "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
              color: "#fc5528",
            },
            {
              question: "Is online booking available for special events?",
              answer:
                "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
              color: "#8139e7",
            },
            {
              question: "Are VIP or special darshan tickets available?",
              answer:
                "Yes, we offer VIP or express darshan bookings at select temples.",
              color: "#8139e7",
            },
          ],
          metaTitle:
            "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
          metaDescription:
            "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
          canonicalLink: "https://www.myomnamo.com/services/darshan-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Darshan Booking",
                item: "https://www.myomnamo.com/services/darshan-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
            url: "https://www.myomnamo.com/services/darshan-booking",
            description:
              "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the Darshan Booking service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our service allows you to book temple darshan online for a hassle-free spiritual experience.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book darshan for multiple people?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can book darshan for yourself, your family, or your friends in one go. Just add their details during booking.",
                },
              },
              {
                "@type": "Question",
                name: "Is online booking available for special events?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can book darshan for festivals, special pujas, or daily visits — even during peak times.",
                },
              },
              {
                "@type": "Question",
                name: "Are VIP or special darshan tickets available?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we offer VIP or express darshan bookings at select temples.",
                },
              },
            ],
          },
          metaData: {
            title:
              "Online Temple Darshan Booking - Plan Your Visit Now with Myomnamo",
            description:
              "Book temple darshan online and avoid waiting. Secure your slot, receive instant confirmation, and focus on your prayers. Start your booking now!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/darshan-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Plan your temple visit easily! Book your darshan in advance and skip the long queues. Whether you are visiting for a festival, special puja, or daily prayers, secure your spot in just a few steps. Enjoy a peaceful visit, offer your prayers, and look for blessings without the stress of waiting. Ideal for families, elderly devotees, or anyone wanting a smooth experience. Focus on your devotion and fully immerse yourself in the sacred atmosphere. Booking your darshan makes your visit more organized, giving you more time for prayer and reflection.",
        },
        {
          headerName: "Temple Puja Booking",
          Imgabout1: About1,
          Imgabout2: poojaAtTemple,
          tagLine: "Embrace Divinity with Temple Pujas",
          serviceBannerImg: PujaAtTempleBannerImg,
          route: "/puja-at-temple",
          cannonicalLink:
            "https://www.myomnamo.com/services/temple-puja-booking",
          serviceName: "temple-puja",
          sectionTitle: "Perform a Sacred Puja at the Temple",
          howItWorksMainHeading: "Receive Sacred Blessings",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Puja",
              howItWorksDesc:
                "Choose from simple offerings or elaborate ceremonies, and personalize rituals for your spiritual intentions.  ",
            },
            {
              howItWorksTitle: "Book Effortlessly",
              howItWorksDesc:
                "From gathering offerings to preparing the sacred space, we ensure everything is ready so you can focus on your prayers without any worries.",
            },
            {
              howItWorksTitle: "Experience Divinity",
              howItWorksDesc:
                "Participate in sacred rituals, chant mantras, and receive blessings for positivity and well-being.",
            },
          ],
          testimonials: [
            {
              Desc: " I booked a puja at the temple, and everything was perfectly arranged. The rituals were performed beautifully, and I felt truly blessed.",
              name: "Anjali Raut",
              location: "Kolhapur",
            },
            {
              Desc: "Booking a temple puja online was so convenient. No long waits, everything was well-organized, and the prasad delivery was a lovely touch",
              name: "Vikas Mane",
              location: "Delhi",
            },
            {
              Desc: "The puja was conducted exactly as promised, with complete devotion and care. It was a peaceful and divine experience. Highly recommended.",
              name: "Priya Kadam",
              location: "Vashi",
            },
            {
              Desc: "We wanted a puja done in a South Indian temple, and Myomnamo made it happen smoothly.",
              name: "Abhay Nadkarni",
              location: "Mumbai",
            },
            {
              Desc: "Myomnamo helped me book a special temple puja for my son’s birthday. Felt truly blessed.",
              name: "Rahul Chitale",
              location: "Solapur",
            },
          ],
          FaqObj: [
            {
              question: "What is the Puja at Temple service?",
              answer:
                "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
              color: "#ffa415",
            },
            {
              question: "How do I book a puja?",
              answer:
                "You can book online or at the temple. Choose the puja type, date, and time.",
              color: "#fc5528",
            },
            {
              question: "What types of pujas are available?",
              answer:
                "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
              color: "#8139e7",
            },
            {
              question: "Are special or private pujas available?",
              answer:
                "Yes, some temples offer private pujas with personalized rituals.",
              color: "#8139e7",
            },
          ],
          metaTitle:
            "Book Temple Puja Online - Sacred Rituals for Every Occasion",
          metaDescription:
            "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
          canonicalLink:
            "https://www.myomnamo.com/services/temple-puja-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Temple Puja",
                item: "https://www.myomnamo.com/services/temple-puja-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Book Temple Puja Online - Sacred Rituals for Every Occasion",
            url: "https://www.myomnamo.com/services/temple-puja-booking",
            description:
              "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the Puja at Temple service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
                },
              },
              {
                "@type": "Question",
                name: "How do I book a puja?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can book online or at the temple. Choose the puja type, date, and time.",
                },
              },
              {
                "@type": "Question",
                name: "What types of pujas are available?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
                },
              },
              {
                "@type": "Question",
                name: "Are special or private pujas available?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, some temples offer private pujas with personalized rituals.",
                },
              },
            ],
          },
          metaData: {
            title:
              "Book Temple Puja Online - Sacred Rituals for Every Occasion",
            description:
              "Book a temple puja for birthdays, anniversaries, or festivals. Experience sacred rituals with care and devotion. Focus on prayers while we handle the rest.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/temple-puja-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Make your temple visit more special with a peaceful puja. Book a puja for any occasion, whether it be birthdays, anniversaries, festivals, or personal prayers. Let the rituals be performed with care and devotion, bringing positivity and blessings into your life. Whether it’s a small offering or a full ceremony, experience the divine atmosphere and connect deeply with your faith. Perfect for individuals, families, or groups looking for a sacred experience. Focus on your prayers while the arrangements are taken care of. Make every visit special and full of positive energy.",
        },
        {
          headerName: "Horoscope Reading",
          Imgabout1: About1,
          Imgabout2: Horoscope,
          tagLine: "Embrace Divinity with Temple Pujas",
          route: "/basic-details",
          serviceBannerImg: HoroscopeBannerImg,
          cannonicalLink: "https://www.myomnamo.com/services/horoscope",
          serviceName: "horoscope",
          sectionTitle: "Know What Your Stars Say",
          howItWorksMainHeading: "How Our Horoscope Reading Works",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Sign",
              howItWorksDesc:
                "Select your zodiac sign to receive a personalized reading about your life, emotions, and future possibilities.",
            },
            {
              howItWorksTitle: "Get Insights Instantly",
              howItWorksDesc:
                "Access daily, weekly, or yearly horoscopes with detailed guidance on love, career, and well-being for extra clarity.",
            },
            {
              howItWorksTitle: "Embrace Your Path",
              howItWorksDesc:
                "Use your horoscope’s advice to make decisions, discover lucky days, and invite more happiness and balance into your life.",
            },
          ],
          testimonials: [
            {
              Desc: "The personalised horoscope report I received from Myomnamo helped me understand many things about my career and personal life. Very insightful.",
              name: "Amit Dumbre",
              location: "Pune",
            },
            {
              Desc: "I wasn’t very serious about astrology before, but the weekly guidance from Myomnamo has actually helped me make better decisions.",
              name: "Vaishali Thakur",
              location: "Nagpur",
            },
            {
              Desc: "Myomnamo’s horoscope reading was detailed and easy to understand. It wasn’t too technical and gave me practical suggestions.",
              name: "Rohit Pansare",
              location: "Nashik",
            },
            {
              Desc: "I started reading the daily horoscope from Myomnamo and it gives me clarity and focus every morning. It feels very accurate and meaningful.",
              name: "Prachi Kelkar",
              location: "Mumbai",
            },
          ],
          FaqObj: [
            {
              question: "What is the Puja at Temple service?",
              answer:
                "Our service allows you to book a temple puja online, ensuring a smooth and hassle-free experience.",
              color: "#ffa415",
            },
            {
              question: "How do I book a puja?",
              answer:
                "You can book online or at the temple. Choose the puja type, date, and time.",
              color: "#fc5528",
            },
            {
              question: "What types of pujas are available?",
              answer:
                "We offer pujas for birthdays, anniversaries, festivals, personal prayers, and special ceremonies.",
              color: "#8139e7",
            },
            {
              question: "Are special or private pujas available?",
              answer:
                "Yes, some temples offer private pujas with personalized rituals.",
              color: "#8139e7",
            },
          ],
          metaTitle: "Horoscope Readings by Zodiac Sign - Know Your Future",
          metaDescription:
            "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
          canonicalLink: "https://www.myomnamo.com/services/horoscope",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Horoscope",
                item: "https://www.myomnamo.com/services/horoscope",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Horoscope Readings by Zodiac Sign - Know Your Future",
            url: "https://www.myomnamo.com/services/horoscope",
            description:
              "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          metaData: {
            title: "Horoscope Readings by Zodiac Sign - Know Your Future",
            description:
              "Find guidance for love, career, and life decisions with a horoscope reading. Explore daily, weekly, or yearly insights tailored to your zodiac sign. Book a consultation.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/horoscope",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Find out what your future holds with a simple horoscope reading. Learn about your day, week, or year efficiently. Get insights about love, work, health, and more. Whether you have a big decision to make or are just curious, a horoscope reading can guide you. Find out lucky days, helpful advice, and ways to bring more happiness into your life. Perfect for anyone looking for extra clarity and peace of mind. Let the stars guide you toward a brighter future.",
        },
        {
          headerName: "Online Prasad Booking Service",
          Imgabout1: About1,
          Imgabout2: Ecart,
          tagLine: "Embrace Divinity with Temple Prasad",
          serviceBannerImg: prasadBooking,
          route: "/prasad-list",
          serviceName: "online-prasad-booking",
          howItWorksMainHeading: "Book Prasad Online with Myomnamo",
          howItWorks: [
            {
              howItWorksTitle: "Choose & Customize",
              howItWorksDesc:
                "Select your preferred prasad, meal time, and quantity. Pick from a variety of sacred offerings prepared with devotion. ",
            },
            {
              howItWorksTitle: "Book & Pay",
              howItWorksDesc:
                "Complete your booking with a few clicks. Enjoy secure payment options for a hassle-free experience",
            },
            {
              howItWorksTitle: "Receive & Blessings",
              howItWorksDesc:
                "Get the divine prasad delivered to your home. Savour the sacred taste and feel the blessings of the divine.",
            },
          ],
          testimonials: [
            {
              Desc: " I ordered a Lakshmi idol and Rudraksha mala, and the quality was amazing. The items were well-packed and delivered on time. Truly satisfied.",
              name: "Puja More",
              location: "Pune",
            },
            {
              Desc: " I purchased a complete puja kit, and it made my rituals so convenient. Everything was authentic and spiritually blessed. Highly recommend.",
              name: "Vikas Rathi",
              location: "Bangalore",
            },
            {
              Desc: "I bought incense sticks and a shankha from the E-Store. The delivery was quick, and the packaging was perfect. Will shop again.",
              name: "Meenal Shinde",
              location: "Jaipur",
            },
            {
              Desc: "I couldn’t go to the temple, but getting prasad made me feel included. Myomnamo is doing a great job.",
              name: "Nitin Korde",
              location: "Pune",
            },
          ],
          FaqObj: [
            {
              question: "Which temples' prasad can I book?",
              answer:
                "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
              color: "#ffa415",
            },
            {
              question: "How long does delivery take?",
              answer:
                "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
              color: "#fc5528",
            },
            {
              question: "Is the prasad prepared hygienically?",
              answer:
                "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
              color: "#8139e7",
            },
            {
              question: "Can I book prasad for special occasions?",
              answer:
                "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
              color: "#8139e7",
            },
          ],
          sectionTitle: "Online Prasad Booking Service",
          metaTitle: "Online Prasad Booking - Receive Divine Blessings at Home",
          metaDescription:
            "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
          cannonicalLink:
            "https://www.myomnamo.com/services/online-prasad-booking",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",

            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Online Prasad Booking",
                item: "https://www.myomnamo.com/services/online-prasad-booking",
              },
            ],
          },
          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Online Prasad Booking - Receive Divine Blessings at Home",
            url: "https://www.myomnamo.com/services/online-prasad-booking",
            description:
              "Book authentic temple prasad online and enjoy sacred blessings at home. Select your meal time and quantity for a convenient spiritual experience. Order Now!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },
          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Which temples' prasad can I book?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can book prasad from famous temples, including Tirupati Balaji, Shirdi Sai Baba, and Ayodhya Ram Mandir, all prepared with traditional devotion.",
                },
              },
              {
                "@type": "Question",
                name: "How long does delivery take?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Delivery time varies by location, but we ensure your prasad reaches you fresh, typically within 3-7 business days after booking.",
                },
              },
              {
                "@type": "Question",
                name: "Is the prasad prepared hygienically?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, all prasad is prepared in temple-approved kitchens following strict hygiene and traditional methods to maintain purity and sanctity.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book prasad for special occasions?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! You can book prasad in bulk for festivals, pujas, or family gatherings and share divine blessings with your loved ones.",
                },
              },
            ],
          },
          metaData: {
            title: "Online Puja Samagri Store - Buy Puja Items at Myomnamo",
            description:
              "Online shopping for authentic Puja samagri and puja items at Myomnamo. Explore a wide range of spiritual products for all your rituals and ceremonies. Fast delivery and trusted quality.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/e-store",
            siteName: "Myomnamo",
            locale: "en_IN",
          },

          mainContent:
            "Book your sacred prasad online with Myomnamo and receive divine blessings at home. Choose fr.om famous temples like Tirupati Balaji, Shirdi Sai Baba, and Ayodhya. Select your preferred date, meal time, and the number of coupons needed. Each prasad is prepared with devotion and love, bringing the temple's spiritual essence to your doorstep. Enjoy the taste of tradition and the comfort of god's grace without leaving your home. Order now and feel the divine connection.",
        },
        {
          headerName: "Book Online Puja Services",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "Book Online Puja Services",
          route: "/services/book-puja",
          serviceBannerImg: PujaBookingBannerImg,
          sectionTitle: "Book Online Puja Services",
          serviceName: "online-puja-services",
          howItWorksMainHeading: "Book Online Puja Services with Myomnamo",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Puja",
              howItWorksDesc:
                "Select from our sacred online pujas and book a skilled pandit for virtual rituals. Schedule your puja at least 2 days in advance.  ",
            },
            {
              howItWorksTitle: "Personalize & Confirm",
              howItWorksDesc:
                "Share your details and intentions for the puja. Receive a confirmation with samagri guidance and live puja timing. ",
            },
            {
              howItWorksTitle: "Witness & Receive Blessings ",
              howItWorksDesc:
                "Join the virtual puja from home, watch the rituals live, and receive divine blessings directly from our experienced pandits. ",
            },
          ],
          testimonials: [
            {
              Desc: "I booked a Satyanarayan Puja through My OmNamo, and everything was perfectly arranged. The pandit was knowledgeable, punctual, and performed the rituals with devotion. Highly recommended.",
              name: "Rajesh Singh",
              location: "Delhi",
            },
            {
              Desc: " My Griha Pravesh Puja was conducted beautifully. The pandit arrived on time with all the required materials. The entire process was smooth and blessed. Thank you, My OmNamo.",
              name: "Priya Mane",
              location: "Nashik",
            },
            {
              Desc: "I needed a Navagraha Shanti puja, and My OmNamo made it so easy! The chanting, rituals, and arrangements were all done perfectly. Truly a divine experience.",
              name: "Amit Kapoor",
              location: "Mumbai",
            },
            {
              Desc: "Booking an online puja was very easy. The communication from Myomnamo was clear, and everything was done with respect.",
              name: "Deepa Naik",
              location: "Kolhapur",
            },
            {
              Desc: "This is a great option for people living far from temples. I’m glad I found it through Myomnamo.",
              name: "Vishal Gokhale",
              location: "Amravati",
            },
          ],
          FaqObj: [
            {
              question: "How does online puja work?",
              answer:
                "You book a puja, our pandit performs it virtually with proper rituals. You can watch live and receive blessings from anywhere. No physical presence is needed.",
              color: "#ffa415",
            },
            {
              question: "Can I customize the puja for my needs?",
              answer:
                "Yes, share your specific wishes during booking. Our pandits tailor the puja accordingly, whether for health, success, or other spiritual purposes. ",
              color: "#fc5528",
            },
            {
              question: "Do I need to arrange puja items?",
              answer:
                "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
              color: "#8139e7",
            },
            {
              question: "Is online puja as effective as offline?",
              answer:
                " Absolutely. The power of puja depends on devotion and proper rituals. Our expert pandits ensure authenticity, making it equally sacred and effective.",
              color: "#8139e7",
            },
          ],
          metaTitle:
            "Book Online Puja Services - Virtual Rituals with Expert Pandits",
          metaDescription:
            "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
          cannonicalLink:
            "https://www.myomnamo.com/services/online-puja-services",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Puja Booking",
                item: "https://www.myomnamo.com/services/puja-booking",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Book Puja Online - Experienced Pandits for All Ceremonies",
            url: "https://www.myomnamo.com/services/puja-booking",
            description:
              "Book a pandit for weddings, housewarming, or any puja. Ensure sacred rituals are performed with care, devotion, and tradition. Start your booking now!",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What types of puja’s can I book?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can book a variety of rituals, including Ganpati puja, Navratri Aarti, Lakshmi puja, and more.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book recurring pujas?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! You can schedule daily, weekly, or multi-day rituals as per your needs.",
                },
              },
              {
                "@type": "Question",
                name: "Are the pandits experienced and qualified?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, all our pandits are experienced, well-trained, and follow proper Vedic rituals.",
                },
              },
              {
                "@type": "Question",
                name: "Can I book a puja for a temple or home location?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can book a puja for your home, temple, or any preferred location.",
                },
              },
              {
                "@type": "Question",
                name: "Do you offer online puja services?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we offer virtual pujas where pandits perform rituals online.",
                },
              },
            ],
          },
          metaData: {
            title:
              "Book Online Puja Services - Virtual Rituals with Expert Pandits",
            description:
              "Book online puja services with experienced pandits. Receive sacred blessings at home through live virtual rituals. Schedule your spiritual experience today!",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-booking",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Book online puja services with Myomnamo and connect with divine blessings from your home. Our trusted and experienced pandits perform puja virtually, ensuring authenticity and devotion. We provide sacred puja samagri and guide you through the setup for a seamless spiritual experience. Whether it's for peace, prosperity, or special occasions, let us help you fulfill your prayers with heartfelt rituals. Experience the power of tradition, no matter where you are. Start your spiritual journey today. Book your online puja now.",
        },
        {
          headerName: "Bhakti Puja kit ",
          Imgabout1: About1,
          Imgabout2: panditBooking,
          tagLine: "Bhakti Kit Details",
          route: "/services/puja-kit",
          serviceBannerImg: LandingPujaKit,
          sectionTitle: "Complete Puja Samagri Kit",
          serviceName: "puja-kit-services",
          howItWorksMainHeading: "Book a Puja Kit Samagri with Myomnamo",
          howItWorks: [
            {
              howItWorksTitle: "Choose Your Subscription",
              howItWorksDesc:
                "Pick a plan that fits you: monthly, quarterly, or yearly and book your puja kit easily online in just a few steps",
            },
            {
              howItWorksTitle: "Personalize & Confirm",
              howItWorksDesc:
                "Share your delivery details and preferences. Receive confirmation, along with a premium wooden box in select plans",
            },
            {
              howItWorksTitle: "Receive & Renew ",
              howItWorksDesc:
                "Get fresh, high-quality samagri delivered to your door. Quarterly and longer plans include monthly ingredient refills for your convenience.",
            },
          ],
          testimonials: [
            {
              Desc: "The puja kit had everything I needed. It was neat and made the puja very easy. Myomnamo thought it through.",
              name: "Laxmi Karale",
              location: "Jalgaon",
            },
            {
              Desc: "Great quality items. Helped me perform all rituals without running to the market.",
              name: "Shrikant Mule",
              location: "Ahilyanagar",
            },
            {
              Desc: "Ordered the kit last minute, but it arrived on time. Very helpful service from Myomnamo.",
              name: "Manasi Gokhale",
              location: "Mumbai",
            },
            {
              Desc: "A complete kit for anyone who wants to do puja at home properly. Thank you Myomnamo.",
              name: "Rahul Pawaskar",
              location: "Ratnagiri",
            },
          ],
          FaqObj: [
            {
              question: " What are the ingredients in the puja kit?",
              answer:
                "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
              color: "#ffa415",
            },
            {
              question: "How often can I get the puja kit delivered?",
              answer:
                "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
              color: "#fc5528",
            },
            {
              question: "Do I need to arrange puja items?",
              answer:
                "No, we provide all sacred samagri. You only need a device (phone/laptop) to join the live session and participate spiritually.",
              color: "#8139e7",
            },
            {
              question: "Are the kits affordable?",
              answer:
                "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
              color: "#8139e7",
            },
            {
              question: "Can I change my subscription later?",
              answer:
                "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
              color: "#8139e7",
            },
          ],
          metaTitle:
            "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
          metaDescription:
            "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
          cannonicalLink: "https://www.myomnamo.com/services/puja-kit-services",
          breadcrumbSchema: {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Puja Booking",
                item: "https://www.myomnamo.com/services/puja-kit-services",
              },
            ],
          },

          webpageSchema: {
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            description:
              "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          },

          faqSchema: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: " What are the ingredients in the puja kit ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Each kit includes all the necessary ingredients for daily or special rituals. Everything is packed to help you perform your puja with ease.",
                },
              },
              {
                "@type": "Question",
                name: " How often can I get the puja kit delivered ?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can choose monthly, quarterly, or yearly delivery. Pick the option that best fits your worship routine.",
                },
              },
              {
                "@type": "Question",
                name: "Are the kits affordable?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, the kits are priced to be budget-friendly. You can maintain your spiritual practices without spending too much.",
                },
              },
              {
                "@type": "Question",
                name: "Can I change my subscription later?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can change or update your plan anytime. We make it easy to adjust your subscription as per your needs.",
                },
              },
            ],
          },
          metaData: {
            title: "Puja Kit Subscription – Monthly, Quarterly, & Annual Plans",
            description:
              "Order ready-to-use puja kits with all the samagri needed for your rituals. A simple, devotional service that brings tradition to your doorstep.",
            image: "https://www.myomnamo.com/assets/images/new/logo.png",
            url: "https://www.myomnamo.com/services/puja-kit-services",
            siteName: "Myomnamo",
            locale: "en_IN",
          },
          mainContent:
            "Get complete puja kits delivered to your doorstep on a monthly, quarterly, or yearly basis at an affordable price. Each kit includes all the necessary items you need for your daily or special rituals, saving you time and effort. Stay connected to your traditions with easy and convenient subscriptions that suit your needs. Trust Myomnamo to make your puja simple and stress-free, so you can focus on your devotion with peace of mind.",
        },
      ]);
    }
  }, [selectedLanguageID]);

  const serviceData = data.find((item) => item.serviceName === servicename);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith("/services/")) {
      const slugPart = path.replace("/services/", "");
      setSlug(slugPart || "default");

      if (slugPart === "horoscope") {
        setShowExitIntentModal(false);
        return; // Stop further execution
      }

      const modalClosed = sessionStorage.getItem("exit_modal_closed");

      // Scroll event listener
      const handleScroll = () => {
        if (!modalClosed && window.scrollY > 300) {
          if (servicename !== "puja-kit-services") {
            setShowExitIntentModal(false);
          }
          window.removeEventListener("scroll", handleScroll); // Remove listener after showing modal
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      setShowExitIntentModal(false);
    }
  }, [location]);

  const owlOptions = {
    items: 1,
    margin: 30,
    loop: false,
    smartSpeed: 700,
    nav: false,
    dots: true,
    autoplay: false,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
    },
  };

  useEffect(() => {
    if (window.scrollY > 200) {
      if (servicename === "daily-puja-booking") {
        GetMyDailyBookPanditPujaListData();
      } else if (servicename === "puja-booking") {
        GetMyBookPanditPujaListData();
      }
    }
  }, [window.scrollY]);

  const GetMyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await GetPopularPujaAPI(null);
      if (response) {
        setLoader(false);
        setPujaListData(response.DATA);
      }

      // if (response) {
      //   setLoader(false);
      //   const newList = response.DATA.filter(
      //     (item) => item.PUJA_TREND === "Yes"
      //   );
      //   setPujaListData(newList);
      // }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetMyDailyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await GetPopularDailyPujaAPI();

      if (response) {
        setLoader(false);
        setDailyPujaListData(response.DATA);
      }

      // if (response) {
      //   setLoader(false);
      //   const newList = response.DATA.filter(
      //     (item) => item.PUJA_TREND === "Yes"
      //   );
      //   setPujaListData(newList);
      // }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const ExitIntenModalOpen = () => {
    setShowExitIntentModal(false);
  };
  const key = location?.state?.key;
  const user_id = localStorage.getItem("userID");

  // const GetMyBookPanditPujaListData = async () => {
  //   setLoader(true);
  //   try {
  //     const response = await MyBookPanditPujaListAPI(user_id, 1, {
  //       START: 1,
  //       END: 10,
  //       WORD: "None",
  //       LATITUDE: "20.008581",
  //       LONGITUDE: "73.76413099999999",
  //     });

  //     if (response) {
  //       setLoader(false);
  //       const newList = response.DATA.filter(
  //         (item) => item.PUJA_TREND === "Yes"
  //       );
  //       setPujaListData(newList);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.log(error);
  //   }
  // };



  const reasons = [
    {
      title: t("Verified and Experienced Pandits"),
      description: t(
        "Our platform connects you with highly qualified and experienced pandits who specialise in Vedic rituals and Hindu ceremonies."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Hassle-Free Booking"),
      description: t(
        "Book your puja online in just a few clicks! Our user-friendly interface allows you to easily select the ceremony, date, and location."
      ),
      icon: <FaRegCalendarCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Customized Rituals"),
      description: t(
        "We offer pujas in different regional styles like North Indian, South Indian, Bengali, and Marathi. Whatever your tradition, we make sure the rituals match your customs and needs."
      ),
      icon: <FaTools size={40} color="#8f3246" />,
    },
    {
      title: t("Convenience at Your Doorstep"),
      description: t(
        "Whether you need a pandit for a home ceremony or a temple ritual, we bring divine blessings to your doorstep with punctual and reliable service."
      ),
      icon: <FaHome size={40} color="#8f3246" />,
    },
    {
      title: t("Customer Satisfaction"),
      description: t(
        "With hundreds of successful pujas conducted, we pride ourselves on delivering exceptional service that leaves our customers spiritually fulfilled and happy."
      ),
      icon: <FaHandshake size={40} color="#8f3246" />,
    },
    {
      title: t("All-Inclusive Packages"),
      description: t(
        "From arranging pandits to providing puja samagri, we handle everything so you can focus on your prayers without stress."
      ),
      icon: <FaBoxOpen size={40} color="#8f3246" />,
    },
  ];

  const PujaBookingWhyChooseUs = [
    {
      title: t("Verified and Experienced Pandits"),
      description: t(
        "Our platform connects you with highly qualified and experienced pandits who specialise in Vedic rituals and Hindu ceremonies."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Hassle-Free Booking"),
      description: t(
        "Book your puja online in just a few clicks! Our user-friendly interface allows you to easily select the ceremony, date, and location."
      ),
      icon: <FaRegCalendarCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Customized Rituals"),
      description: t(
        "We offer pujas in different regional styles like North Indian, South Indian, Bengali, and Marathi. Whatever your tradition, we make sure the rituals match your customs and needs."
      ),
      icon: <FaTools size={40} color="#8f3246" />,
    },
    {
      title: t("Convenience at Your Doorstep"),
      description: t(
        "Whether you need a pandit for a home ceremony or a temple ritual, we bring divine blessings to your doorstep with punctual and reliable service."
      ),
      icon: <FaHome size={40} color="#8f3246" />,
    },
    {
      title: t("Customer Satisfaction"),
      description: t(
        "With hundreds of successful pujas conducted, we pride ourselves on delivering exceptional service that leaves our customers spiritually fulfilled and happy."
      ),
      icon: <FaHandshake size={40} color="#8f3246" />,
    },
    {
      title: t("All-Inclusive Packages"),
      description: t(
        "From arranging pandits to providing puja samagri, we handle everything so you can focus on your prayers without stress."
      ),
      icon: <FaBoxOpen size={40} color="#8f3246" />,
    },
  ];
  const DailyPujaBookingWhyChooseUs = [
    {
      title: t("Experienced Pandits"),
      description: t(
        "Daily pujas are performed by skilled pandits with deep knowledge of Vedic rituals, ensuring authenticity."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Convenient Booking"),
      description: t(
        "Easily book a pandit for daily puja at your preferred time, bringing spiritual practices to your doorstep"
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Personalized Rituals"),
      description: t(
        "We handle each puja with precision, respect, and customization, catering to your specific needs and traditions."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Comprehensive Service"),
      description: t(
        "From mantra chanting to aarti, we ensure every aspect of your daily puja is performed accurately and traditionally."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Positive Environment"),
      description: t(
        "Invite peace, positivity, and divine blessings into your home with our dedicated and devoted puja services."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Trusted Guidance"),
      description: t(
        "Experience divine blessings every day with a trusted pandit guiding your rituals, fostering a deeper connection."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const DarshanBookingWhyChooseUs = [
    {
      title: "Skip the Lines",
      description:
        "Book your darshan online in advance, avoiding long queues and saving valuable time for a peaceful temple visit.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Easy Booking Process",
      description:
        "Our user-friendly platform allows you to book your darshan in just a few simple steps, making the process quick and convenient.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Plan with Ease",
      description:
        "Organize your temple visit easily, selecting your preferred date and time slot to align with your travel schedule.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Ideal for Everyone",
      description:
        "Whether you're a family, elderly devotee, or individual, our service ensures a smooth and stress-free experience for all.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Guaranteed Entry",
      description:
        "Ensure your spot for festivals, special pujas, or daily prayers with a confirmed darshan booking.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Organized Visit",
      description:
        "By booking your darshan, you'll have a more structured visit, providing you with ample time for prayer, reflection, and spiritual fulfilment.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const TempleBookingWhyChooseUs = [
    {
      title: "Easy Booking",
      description:
        "Book any temple puja online, anytime, from anywhere, quickly, simply, and hassle-free.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Experienced Pandits",
      description:
        "Our skilled and verified pandits perform rituals with full devotion and tradition.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Services",
      description:
        "Choose pujas to your needs, occasions, and preferences for a meaningful spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Live Updates",
      description:
        "Get real-time notifications on puja status and timing for peace of mind.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Safe Payments",
      description:
        "Make secure online payments with full data encryption and protection.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "One-Stop Spiritual Hub",
      description:
        "Access all spiritual services, pandit booking, pujas, and darshan tickets in one place.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const HoroscopeWhyChooseUs = [
    {
      title: t("Daily Zodiac Sign"),
      description: t(
        "Get daily insights specific to your zodiac sign for better life alignment."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Accurate Predictions"),
      description: t(
        "Get clear insights with precise forecasts based on your zodiac sign."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Personalized Guidance"),
      description: t(
        "Experienced astrologer gives you customised insights to navigate life’s challenges and opportunities effectively."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Everyday Sunrise Sunset Information"),
      description: t(
        "With a horoscope, stay updated with daily sunrise and sunset timings for spiritual harmony."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Pre-Update on Festivals"),
      description: t(
        "You will receive advance notifications for upcoming festivals and auspicious dates."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Panchang Information"),
      description: t(
        "We provide detailed Panchang data for informed decision-making and rituals."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];

  const EStoreWhyChooseUs = [
    {
      title: t("Authentic Products Only"),
      description: t(
        "We offer 100% authentic and traditional puja samagri sourced from trusted vendors to maintain the sanctity of rituals."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("All-In-One Puja Kits"),
      description: t(
        "Ready-to-use kits include every essential item needed for specific pujas, saving time and ensuring nothing is missed."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Wide Range of Items"),
      description: t(
        "Explore an extensive collection of quality incense sticks, dhoop, kapur, and sacred items for every kind of puja."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Nationwide Delivery"),
      description: t(
        "We deliver across India with safe packaging to preserve the purity and freshness of every puja item you order."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Trusted by Devotees"),
      description: t(
        "Thousands of satisfied customers trust our service for prompt delivery and the spiritual value of our curated samagri."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: t("Easy Online Ordering"),
      description: t(
        "Enjoy a hassle-free shopping experience with secure payment options and doorstep delivery for all your spiritual needs."
      ),
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];

  const OnlinePujaWhyChooseUs = [
    {
      title: "Trusted & Vedic Pandits",
      description:
        "Our certified pandits have decades of experience, ensuring authentic Vedic rituals with proper mantras and vidhi for divine blessings.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Live Virtual Puja Experience",
      description:
        " Witness your puja in real-time via video call, interact with the pandit, and feel spiritually connected from anywhere in the world. ",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Flexible Scheduling",
      description:
        " Book pujas 48 hours in advance at your preferred time, including weekends, for a seamless spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Personalized Devotion",
      description:
        "Share your specific prayers and intentions—our pandits perform rituals with your needs in mind for a heartfelt connection.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Spiritual Guidance",
      description:
        "Get expert advice on rituals, mantras, and post-puja practices to deepen your connection with the divine effortlessly.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Easy Online Ordering",
      description:
        "Enjoy a hassle-free shopping experience with secure payment options and doorstep delivery for all your spiritual needs.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const PrasadWhyChooseUs = [
    {
      title: "Divine Blessings at Home",
      description:
        " Receive sacred prasad from famous temples, bringing the temple's spiritual essence and blessings directly to your doorstep.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Taste of Tradition",
      description:
        "Enjoy authentic, traditionally prepared prasad, made with devotion and the finest ingredients, offering a unique spiritual experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Convenient and Easy",
      description:
        "Select your preferred date, meal time, and quantity, making it simple to receive divine offerings without leaving your home.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
    {
      title: "Prepared with Devotion",
      description:
        " Each prasad is crafted with love and care, ensuring that you receive a pure and blessed offering from the chosen temple.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Connect with the Divine",
      description:
        "Strengthen your spiritual connection and feel the comfort of God's grace through the sacred taste of blessed prasad.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },

    {
      title: "Hassle-Free Experience",
      description:
        "Skip the travel and long queues; order your prasad online with a few clicks for a seamless and fulfilling experience.",
      icon: <FaUserCheck size={40} color="#8f3246" />,
    },
  ];
  const serviceReasonsMap = {
    "puja-booking": PujaBookingWhyChooseUs,
    "daily-puja-booking": DailyPujaBookingWhyChooseUs,
    "darshan-booking": DarshanBookingWhyChooseUs,
    "temple-puja": TempleBookingWhyChooseUs,
    horoscope: HoroscopeWhyChooseUs,
    "e-store": EStoreWhyChooseUs,
    "online-prasad-booking": PrasadWhyChooseUs,
    "online-puja-services": OnlinePujaWhyChooseUs,
  };

  const GetUserModelData = async (value) => {
    // setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    if (userID === null || userID === undefined) {
      // navigate("/");
      setShowOpenLoginModal(true);
    }
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        // setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item
        if (
          ModelData[0]?.DOB === null ||
          ModelData[0]?.DOB === undefined ||
          ModelData[0]?.DOB === ""
        ) {
          ItemAddedToast();
          navigate("/horoscope/my-profile", {
            state: { modelName: "Horoscope" },
          });
        } else {
          navigate(value?.route);
        }
      } else {
        // setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };
  const handleOnConfirm = () => { };

  const selectedReasons = serviceReasonsMap[servicename] || reasons;
  return (
    <div>

      {serviceData?.serviceName === "e-store" && (
        <section className="page-header" style={{ paddingBottom: "28px" }}>
          <div
            className="page-header__bg horoscope-banner-responsive"
            style={{ backgroundImage: `url(${serviceData?.serviceBannerImg})` }}
          ></div>
          <div className="container" style={{ display: "block" }}>
            <h2 className="page-header__title bw-split-in-left">
              {t("Online Puja Samagri Store")}
            </h2>
            <div></div>
          </div>
        </section>
      )}


      <Helmet>
        <title>{serviceData.metaTitle}</title>
        <meta name="description" content={serviceData.metaDescription} />
        <link rel="canonical" href={serviceData.cannonicalLink} />

        {/* Open Graph tags */}
        <meta property="og:title" content={serviceData.metaData.title} />
        <meta
          property="og:description"
          content={serviceData.metaData.description}
        />
        <meta property="og:image" content={serviceData.metaData.image} />
        <meta property="og:url" content={serviceData.metaData.url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={serviceData.metaData.siteName} />
        <meta
          property="og:locale"
          content={serviceData.metaData.locale || "en_IN"}
        />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={serviceData.metaData.title} />
        <meta
          name="twitter:description"
          content={serviceData.metaData.description}
        />
        <meta name="twitter:image" content={serviceData.metaData.image} />

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(serviceData.breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(serviceData.webpageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(serviceData.faqSchema)}
        </script>
      </Helmet>

      <section
        className="estore"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "60px",
          marginBottom: "0px",
        }}
      >
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-md-12 wow fadeInRight" data-wow-delay="200ms">
              <div
                className="about-one__content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "20px",
                  border: "4px solid #ffa4154a",
                  backgroundColor: "#ffa4151f",
                }}
              >
                <div
                  className="sec-title text-center"
                  style={{ paddingBottom: "0px" }}
                >
                  <h6 className="sec-title__tagline bw-split-in-right d-flex align-items-center justify-content-center">
                    <img className="tagline-img me-2" src={batuk} alt="" />
                    {serviceData.tagLine}
                  </h6>

                  <h3 className="sec-title__title bw-split-in-left">
                    {serviceData.sectionTitle}
                  </h3>
                </div>

                <p
                  className="about-one__content__text"
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    marginBottom: "0px",
                  }}
                >
                  {serviceData.mainContent}
                </p>

                {serviceData.serviceName === "horoscope" ? (
                  <div className="mt-3">
                    <Link
                      onClick={() => GetUserModelData(serviceData)}
                      className="careox-btn"
                    >
                      View Details
                    </Link>
                  </div>
                ) : (
                  serviceData.serviceName !== "puja-kit-services" && (
                    <div className="mt-0">
                      <Link to={serviceData.route}>
                        <button
                          className="careox-btn"
                          style={{ marginBottom: "0px" }}
                        >
                          {`${serviceData.serviceName === "e-store" ||
                            serviceData.serviceName === "online-prasad-booking"
                            ? t("Order Now")
                            : t("Book Now")
                            }`}
                        </button>
                      </Link>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {servicename === "puja-booking" ||
        servicename === "online-puja-services" ? (
        <LazySection>
          <TrendingCategoriesSection />
        </LazySection>
      ) : servicename === "e-store" ? (
        <LazySection>
          <TrendingStoreProductsCategory show={true} moduleName={"eStore"} />
        </LazySection>
      ) : servicename === "online-prasad-booking" ? (
        <TrendingStoreProductsCategory show={true} moduleName={"prasad"} />
      ) : servicename === "horoscope" ? (
        <LazySection>
          <HoroscopeListCards />
        </LazySection>
      ) : (
        ""
      )}

      {servicename === "puja-kit-services" && (
        <LazySection>
          <PujaKitSubscriptionLandingPage />
        </LazySection>
      )}
      {/* How it works */}

      <section
        className="service-one respnsiveestore"
        style={{ padding: "70px 0", backgroundColor: "#fff" }}
      >
        <div
          className="service-one__shape-two"
          style={{
            backgroundImage: `url(${shape2})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="container">
          {" "}
          {/* ✅ Keeps proper side margins */}
          <div className="row">
            <div className="col-12">
              {/* Section Title */}
              <div
                className="section-title text-center mb-5"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h6 className="sec-title__tagline bw-split-in-right">
                  <img className="tagline-img" src={batuk} alt="" />
                  {t("How It Works")}
                </h6>

                <h3 className="sec-title__title bw-split-in-left">
                  {serviceData.howItWorksMainHeading}
                </h3>
              </div>

              {/* Card Section */}
              <div className="row justify-content-center g-4">
                {serviceData.howItWorks?.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-lg-4 d-flex" // ✅ 1 / 2 / 3 cards per row
                  >
                    <div
                      className="service-one__item text-center d-flex flex-column h-100 shadow-sm border-0 p-4"
                      style={{
                        borderRadius: "12px",
                        background: "#f9f9f9",
                      }}
                    >
                      <div className="service-one__item__icon mb-3">
                        <img src={Batuk} alt="careox" height={50} width={50} />
                      </div>

                      <h3
                        className="service-one__item__title mb-2"
                        style={{
                          textAlign: "center",
                          fontWeight: "600",
                        }}
                      >
                        {item?.howItWorksTitle}
                      </h3>

                      <p
                        className="service-one__item__text flex-grow-1"
                        style={{
                          textAlign: "center",
                          wordBreak: "break-word",
                          lineHeight: "1.6",
                          fontFamily: "Bricolage Grotesque",
                        }}
                      >
                        {item?.howItWorksDesc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Popular pujas */}

      {(servicename === "puja-booking" ||
        servicename === "daily-puja-booking") && (
          <section
            className="service-one"
            style={{ padding: "30px 0", background: "white" }}
          >
            <div className="container">
              <div className="row gutter-y-30 d-flex align-center justify-center">
                <div className="col-12">
                  <div
                    className="section-title text-center"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{ color: "#A52444" }}
                    >
                      <img className="tagline-img" src={batuk} alt="" />
                      {servicename === "daily-puja-booking"
                        ? t("Popular Daily Pujas")
                        : t("Popular Pujas")}
                    </h6>

                    <h3 className="sec-title__title bw-split-in-left">
                      {t("Sacred rituals trusted by devotees worldwide.")}
                    </h3>
                  </div>

                  {/* Scrollable container for mobile */}
                  <div
                    className="scroll-container d-flex"
                    style={{
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      gap: "20px",
                      padding: "10px 0",
                      flexWrap: "nowrap",
                      scrollBehavior: "smooth",
                      justifyContent: "center",
                    }}
                  >
                    {(servicename === "puja-booking"
                      ? pujaListData?.slice(0, 4)
                      : servicename === "daily-puja-booking"
                        ? pujaDailyListData?.slice(0, 4)
                        : []
                    )?.map((item, index) => {
                      const isDaily = servicename === "daily-puja-booking";
                      const link = isDaily
                        ? `/services/daily-booking/puja-details/${item?.DailyPujaSlug}`
                        : `/services/book-puja/${item?.PujaSlug}`;
                      const name = isDaily ? item?.DP_NAME : item?.PUJA_NAME;
                      const price = isDaily ? item?.DP_PRICE : item?.PUJA_PRICE;
                      const image = isDaily
                        ? placeholderImg
                        : item?.PUJA_IMAGE || placeholderImg;

                      return (
                        <Link
                          key={index}
                          to={link}
                          state={{ product: item }}
                          style={{ width: "min-content" }}
                        >
                          <div
                            className="product-item-one"
                            style={{
                              minWidth: "200px",
                              maxWidth: "240px",
                              flex: "0 0 auto",
                              height: "340px",
                              marginBottom: "10px",
                            }}
                          >
                            <div
                              className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="product-image text-center position-relative">
                                <img
                                  src={image}
                                  className="img-fluid rounded w-100"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholderImg;
                                  }}
                                  style={{
                                    objectFit: "contain",
                                    height: "180px",
                                  }}
                                />
                              </div>
                              <div
                                className="product-details text-center d-flex align-items-center justify-content-center flex-column flex-grow-1 p-2"
                                style={{ margin: "0" }}
                              >
                                <h6
                                  style={{
                                    fontSize: "18px",
                                    color: "#8f3246",
                                    fontWeight: "600",
                                  }}
                                >
                                  {name}
                                </h6>
                                <div className="prod-details d-flex align-items-center flex-column">
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    ₹ {price}
                                  </span>
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      color: "#a52444",
                                      fontSize: "15px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    View Details{" "}
                                    <i className="icon-right-arrow"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

      {servicename !== "puja-kit-services" && (
        <>
          {/* <section
            className="d-flex align-items-center"
            style={{
              backgroundImage: `url(${bg}) no-repeat center center`,

              backgroundSize: "cover",
              backgroundColor: "#E7E0E0",
              minHeight: "230px",
            }}
          >
            <div className="container">
              <div
                className="row align-items-center justify-content-center text-center text-lg-center"
                style={{ padding: "20px 0px" }}
              >

                <div className="col-lg-6 mb-4 mb-lg-0">
                  <h2
                    className="fw-bold text-dark mb-4"
                    style={{ color: "#791818", textAlign: "center" }}
                  >
                    {t("Download Myomnamo app now")} !!
                  </h2>
                  <div className="d-flex justify-content-center justify-content-lg-center align-items-center">
                    <a
                      href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="me-3"
                    >
                      <img src={playStore} alt="Google Play" height="50" />
                    </a>
                    <a

                      onClick={() => setShowComingSoonModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={ios} alt="App Store" height="50" />
                    </a>
                  </div>
                </div>

                <div
                  className="col-lg-6 text-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={AppImg}
                    alt="App with Pandit Character"
                    width={200}
                    height={200}
                    className="img-fluid"
                    style={{ maxHeight: "320px" }}
                  />
                </div>
              </div>
            </div>
          </section> */}

          <LazySection><DownloadApp languageID={selectedLanguageID} /></LazySection>
        </>
      )}
      {/* Why choose us */}
      {servicename !== "puja-kit-services" && (
        <section
          className="py-5 text-center"
          style={{ backgroundColor: "#f1f6f7" }}
        >
          <div className="container">
            {" "}
            {/* ✅ container keeps section width consistent */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="section-title text-left" style={{ marginBottom: "0px" }}>
                <h6
                  className="section-title__tagline bw-split-in-right"
                  style={{ color: "#A52444" }}
                >
                  <img className="tagline-img" src={batuk} alt="" />
                  {t("Why Choose Us")}
                </h6>
                <h3 className="sec-title__title bw-split-in-left">
                  {t("Myomnamo offers easy, authentic puja services trusted by thousands of devotees.")}
                </h3>
              </div>


              {/* Cards Section */}
              <div
                className="row justify-content-center g-4 mt-4"
                style={{ margin: 0 }}
              >
                {selectedReasons.map((reason, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-lg-4 d-flex" // ✅ 1 on mobile, 2 on tablet, 3 on desktop
                  >
                    <div
                      className="card shadow-sm border-0 p-4 text-center w-100"
                      style={{
                        minHeight: "100%",
                        borderRadius: "12px",
                        background: "#fff",
                      }}
                    >
                      <div className="mb-3">{reason.icon}</div>
                      <h5 className="fw-bold mb-2">{reason.title}</h5>
                      <p
                        style={{
                          textAlign: "center",
                          wordBreak: "break-word",
                          lineHeight: "1.6",
                        }}
                      >
                        {reason.description?.replace(/\s+/g, " ")}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}



      {/* Testimonials */}
      {/* {servicename !== 'puja-kit-services' && ( */}
      <section
        className="testimonials-page"
        style={{ backgroundColor: "white" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title text-center">
                <h6
                  className="sec-title__tagline bw-split-in-right"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img className=" tagline-img" src={batuk} alt="" />
                  {t("Testimonials")}
                </h6>
                <h3
                  className="sec-title__title bw-split-in-left"
                  style={{ textAlign: "center" }}
                >
                  {t("Devotee Testimonials")}
                </h3>
              </div>
              <OwlCarousel
                className="testimonials-page__carousel careox-owl__carousel careox-owl__carousel--with-shadow careox-owl__carousel--basic-nav owl-carousel owl-theme"
                {...owlOptions}
              >
                {serviceData.testimonials.map((testimonial, index) => (
                  <div
                    className="item"
                    key={index}
                  // style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="testimonials-page__card"
                      style={{
                        color: "black",
                        height: "auto",
                        // backgroundColor: "white",
                      }}
                    >
                      {/* <div className="testimonials-page__card__image">
                 <img src={testimonial.image} alt={testimonial.name} />
               </div> */}
                      <div className="testimonials-page__card__rating">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="icofont-star"></i>
                        ))}
                      </div>
                      <div className="testimonials-page__card__content">
                        {testimonial.Desc}
                      </div>
                      <h3 className="testimonials-page__card__name">
                        {testimonial.name}
                      </h3>
                      <p className="testimonials-page__card__designation">
                        {testimonial.location}
                      </p>
                      <div className="testimonials-page__card__quote">
                        <i className="icofont-quote-left"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
      {/* )} */}

      {/* <FAQSection /> */}

      <section className="faq-one faq-one--page">
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="section-title text-center">
            <h6
              className="sec-title__tagline bw-split-in-right"
              style={{
                perspective: "400px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
              <img className=" tagline-img" src={batuk} alt="" /> {t("FAQ's")}
              {/* <span className="sec-title__tagline__border"></span> FAQ */}
            </h6>
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ perspective: "400px", textAlign: "center" }}
            >
              {t("Frequently Asked Questions")}
            </h3>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="faq-one__accordion careox-accordion">
                {serviceData.FaqObj.map((faq, index) => (
                  <div
                    key={index}
                    className={`accrodion ${activeIndex === index ? "active" : ""
                      }`}
                    style={{ "--accent-color": faq.color }}
                  >
                    <div
                      className="accrodion-title"
                      onClick={() => toggleFAQ(index)}
                    >
                      <h4>
                        <span
                          className="accrodion-title__number"
                          style={{ marginRight: "10px", fontWeight: "500" }}
                        ></span>
                        {faq.question}
                        <span className="accrodion-title__icon"></span>
                      </h4>
                    </div>
                    <div
                      className="accrodion-content"
                      style={{
                        maxHeight: activeIndex === index ? "200px" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease-in-out",
                      }}
                    >
                      <div className="inner">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <ExitIntentModal
              slug={slug}
              show={showExitIntentModal}
              onHide={() => {
                setShowExitIntentModal(false);
              }}
            />
          </div>
        </div>
      </section>
      {servicename !== "puja-kit-services" && (
        <LazySection>
          <BlogCarousel />
        </LazySection>
      )}

      <LoginPopUp
        show={showOpenLoginModal}
        onHide={() => setShowOpenLoginModal(false)}
        onConfirm={handleOnConfirm}
      />
      <ComingSoonModal
        show={showComingsoonModal}
        onClose={() => setShowComingSoonModal(false)}
      />
    </div>
  );
};

export default ServicesLandingPage;
